<template>
  <section class="all-cases-view">
    <div class="navbarComponent">
      <div class="container-default">
        <div class="listings-navbar">
          <el-row gutter="20" style="row-gap: 5px">
            <el-col :lg="14" :xl="14" class="toolbar-left">
              <ul class="d-flex list-items-group-15 barcode-print">
                <li v-if="samplesReceivedTab">
                  <el-button
                    class="btn button-with-icon"
                    :disabled="!selectedCaseIds.length"
                    @click="onSamplesReceivedBarButton"
                  >
                    <span>BULK ACKNOWLEDGMENT</span>
                  </el-button>
                </li>
                <li v-if="hasPermission('generate_barcode', 'view')">
                  <el-dropdown
                    trigger="click"
                    placement="bottom-start"
                    @command="onBarcodeMenuCommand"
                  >
                    <el-button class="btn button-with-icon">
                      <span class="mr-5">
                        <img
                          src="@/assets/images/new-barcode-icon-white.svg"
                          alt="icon"
                          class="active"
                        />
                        <img
                          class="inactive"
                          src="@/assets/images/new-barcode-icon.svg"
                          alt="icon"
                        />
                      </span>
                      <span>BARCODES</span>
                      <svg
                        class="barcode-menu-chevron"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M2.5 4.5 6 8l3.5-3.5"
                          stroke="currentColor"
                          stroke-width="1.6"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </el-button>
                    <template #dropdown>
                      <el-dropdown-menu class="barcode-menu">
                        <!-- With cases selected the options print for those cases;
                             otherwise they ask for a date range. -->
                        <el-dropdown-item
                          v-for="option in barcodeMenuOptions"
                          :key="option.command"
                          :command="option.command"
                        >
                          <div class="barcode-menu-item">
                            <span class="barcode-menu-title">{{ option.title }}</span>
                            <span class="barcode-menu-description">{{ option.description }}</span>
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </li>
                <li v-if="selectedFaxFlag">
                  <el-button
                    class="btn button-with-icon"
                    :loading="bulkFaxLoading"
                    :disabled="!selectedCaseIds.length || isClientSalesUser"
                    @click="onBulkSendFax"
                  >
                    <span>BULK SEND FAX</span>
                  </el-button>
                </li>
                <li>
                  <div
                    class="form-element input-with-icon search-input-lg w-200 has-search-shortcut"
                  >
                    <el-input
                      ref="searchShortcutInput"
                      placeholder="Accession / Order ID / MLX Order ID / Patient Name"
                      v-model="search_string"
                      @input="getAutoCompleteCases()"
                      @clear="onSearchClear()"
                      :clearable="true"
                    ></el-input>
                    <span v-if="!search_string" class="search-shortcut-hint"><kbd v-for="key in searchShortcutKeys" :key="key">{{ key }}</kbd></span>
                    <span v-if="searching">
                      <i class="el-icon-loading icon" title="Searching…"></i>
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :lg="10" :xl="10" class="toolbar-right">
              <ul class="d-flex justify-content-end list-items-group-15">
                <li>
                  <div class="search-with-date-input">
                    <el-date-picker
                      v-model="fromDate"
                      type="date"
                      :placeholder="fromDatePlaceholder"
                      format="MM-DD-YYYY"
                      :clearable="true"
                      :disabled-date="disabledFromDate"
                      @change="onFromDateChange"
                      value-format="YYYY-MM-DD"
                      style="width: 100%"
                    />
                  </div>
                </li>
                <li>
                  <div class="search-with-date-input">
                    <el-date-picker
                      v-model="toDate"
                      type="date"
                      :placeholder="toDatePlaceholder"
                      format="MM-DD-YYYY"
                      :clearable="true"
                      value-format="YYYY-MM-DD"
                      :disabled-date="disabledToDate"
                      style="width: 100%"
                      @change="handleCurrentChange(1)"
                    />
                  </div>
                </li>
                <li>
                  <el-button
                    class="btn button-with-icon"
                    @click="onReportsExport"
                  >
                    <span class="mr-8">
                      <img
                        src="@/assets/images/icons/export-icon-with-bg-blue.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/export-icon-white.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                    <span>Export</span>
                  </el-button>
                </li>
                <li>
                  <el-button
                    @click="showFilters = !showFilters"
                    class="filter-toggle-btn"
                  >
                    {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
                  </el-button>
                </li>
                <li>
                  <el-button class="filter-clear-btn" @click="clearAllFilters">
                    Clear Filters
                  </el-button>
                </li>
                <li v-if="showFilters">
                  <el-popover
                    placement="bottom-end"
                    :width="250"
                    trigger="click"
                    popper-class="filter-customize-popover"
                  >
                    <template #reference>
                      <el-button class="filter-customize-btn" title="Customize filters">
                        Customize Filters
                      </el-button>
                    </template>
                    <div class="filter-customize-panel">
                      <p class="fc-title">Date range applies to</p>
                      <div class="fc-date-type">
                        <el-select
                          v-model="dateType"
                          placeholder="Date Type"
                          default-first-option
                          @change="onDateTypeChange"
                        >
                          <el-option
                            v-for="opt in dateTypeOptions"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          />
                        </el-select>
                      </div>
                      <p class="fc-title">Show / hide &amp; drag to reorder</p>
                      <div
                        v-for="f in customizableFilters"
                        :key="f.key"
                        class="fc-row"
                      >
                        <el-checkbox
                          :model-value="!hiddenFilters.includes(f.key)"
                          @change="toggleFilterVisibility(f.key)"
                        >
                          {{ f.label }}
                        </el-checkbox>
                      </div>
                      <el-button
                        text
                        size="small"
                        class="fc-reset"
                        @click="resetFilterPreferences"
                      >
                        Reset to default
                      </el-button>
                    </div>
                  </el-popover>
                </li>
              </ul>
            </el-col>
          </el-row>
          <el-row v-if="crossLabRegistered" style="margin-top: 10px">
            <el-col :span="24">
              <ul class="d-flex flex-wrap list-items-group-15">
                <li>
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="crossLabCaseStatus"
                      placeholder="Case Status"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                      clearable
                      multiple
                      collapse-tags
                      collapse-tags-tooltip
                      :max-collapse-tags="1"
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="status in crossLabStatusOptions"
                        :key="status.value"
                        :label="status.label"
                        :value="status.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </li>
                <li>
                  <div
                    class="form-element search-with-filter-input"
                    style="width: 230px"
                  >
                    <el-select
                      v-model="crossLabFinaliseFrom"
                      placeholder="Should Finalise From"
                      clearable
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="location in crossLabFinaliseFromOptions"
                        :key="location"
                        :label="location"
                        :value="location"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </li>
              </ul>
            </el-col>
          </el-row>
          <transition name="slide-filters">
          <el-row v-show="showFilters" style="margin-top: 10px;">
            <el-col :span="24">
              <draggable
                v-model="orderedVisibleFilters"
                item-key="key"
                tag="ul"
                class="d-flex flex-wrap list-items-group-15 filters-draggable"
                style="row-gap: 10px;"
                handle=".filter-drag-handle"
                ghost-class="filter-ghost"
              >
                <template #item="{ element }">
                  <li class="filter-drag-item">
                    <span class="filter-drag-handle" title="Drag to reorder">⠿</span>
                    <template v-if="element.key === 'patient_name'">
                      <div class="form-element search-with-filter-input">
                        <el-input
                          placeholder="Patient Name"
                          v-model="patient_name"
                          @input="getAutoCompleteCases()"
                          @clear="getAutoCompleteCases()"
                          :clearable="true"
                        ></el-input>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'stat'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="isStatSort"
                          placeholder="Order by STAT"
                          clearable
                          default-first-option
                          :reserve-keyword="false"
                          @change="handleStatToggle(isStatSort)"
                        >
                          <el-option label="Yes" :value="true"></el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'date_of_birth'">
                      <div class="search-with-date-input">
                        <el-date-picker
                          format="MM-DD-YYYY"
                          v-model="date_of_birth"
                          :disabled-date="disabledDate"
                          @change="handleCurrentChange(1)"
                          placeholder="Patient DOB"
                          :clearable="true"
                        ></el-date-picker>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'ordering_facility'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="selectedHospital"
                          placeholder="Ordering Facility"
                          default-first-option
                          :reserve-keyword="false"
                          filterable
                          clearable
                          multiple
                          collapse-tags
                          collapse-tags-tooltip
                          :max-collapse-tags="1"
                          value-key="_id"
                          @change="onHospitalChange"
                          @focus="onHospitalFocus"
                          remote
                          :remote-method="remoteMethodFacility"
                          :loading="hospitalLoading"
                        >
                          <el-option
                            v-for="hospital in hospitalsData.data"
                            :key="hospital"
                            :label="hospital.name"
                            :value="hospital"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'physician'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="physician"
                          placeholder="Physician"
                          default-first-option
                          :reserve-keyword="false"
                          filterable
                          clearable
                          multiple
                          collapse-tags
                          collapse-tags-tooltip
                          :max-collapse-tags="1"
                          @change="handleCurrentChange(1)"
                          @focus="onPhysicianFocus"
                          :loading="physicianLoading"
                          remote
                          :remote-method="remoteMethodPhysician"
                        >
                          <el-option
                            v-for="physician in physiciansData.data"
                            :key="physician"
                            :label="physician.name"
                            :value="physician._id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'case_type'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="caseType"
                          placeholder="Case Type"
                          filterable
                          clearable
                          multiple
                          collapse-tags
                          collapse-tags-tooltip
                          :max-collapse-tags="1"
                          default-first-option
                          :reserve-keyword="false"
                          @change="handleCurrentChangeCaseType(1)"
                        >
                          <el-option
                            v-for="caseType in getAuthenticatedUser.user_type == 'LAB_TECHNOLOGIST' && getAuthenticatedUser.allowed_case_types ? getUserBasedCaseTypes(caseTypes) : getLabBasedCaseTypes(caseTypes)"
                            :key="caseType"
                            :label="caseType.label"
                            :value="caseType.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'test_id'">
                      <div class="form-element search-with-filter-input trigger-drowpdown">
                        <el-select
                          v-model="test_info"
                          placeholder="Select Test Id"
                          filterable
                          clearable
                          multiple
                          collapse-tags
                          default-first-option
                          :reserve-keyword="false"
                          @change="handleTest(1)"
                        >
                          <el-option
                            v-for="test in testIds"
                            :key="test"
                            :label="test.category"
                            :value="test.tests"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'sales_rep'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="hospital_marketer"
                          placeholder="Sales Rep"
                          default-first-option
                          :reserve-keyword="false"
                          filterable
                          clearable
                          @change="handleCurrentChange(1)"
                          @focus="fetchAllUsers"
                          :loading="userLoading"
                          multiple
                          collapse-tags
                        >
                          <el-option
                            v-for="(user, index) in marketerData"
                            :key="index"
                            :label="user.first_name + ' ' + user.last_name"
                            :value="user._id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'assigned_to'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="test_performed_by"
                          placeholder="Assigned to"
                          default-first-option
                          :reserve-keyword="false"
                          filterable
                          clearable
                          multiple
                          collapse-tags
                          collapse-tags-tooltip
                          :max-collapse-tags="1"
                          @change="handleCurrentChange(1)"
                          @focus="fetchAllUsers"
                          :loading="userLoading"
                        >
                          <el-option
                            v-for="(user, index) in usersList"
                            :key="index"
                            :label="user.first_name + ' ' + user.last_name"
                            :value="user._id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'accession_created_by'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="accessionCreatedBy"
                          placeholder="Accession Created By"
                          filterable
                          remote
                          :remote-method="remoteMethodAccessionCreator"
                          clearable
                          multiple
                          collapse-tags
                          collapse-tags-tooltip
                          :max-collapse-tags="1"
                          @change="onAccessionCreatorChange"
                          @focus="fetchAccessionCreators()"
                          :loading="userLoading"
                        >
                          <el-option
                            v-for="(user, index) in accessionCreators"
                            :key="index"
                            :label="user.first_name + ' ' + user.last_name"
                            :value="user._id"
                          />
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'exception'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="billing_sub_status"
                          placeholder="Exception"
                          default-first-option
                          :reserve-keyword="false"
                          filterable
                          clearable
                          multiple
                          collapse-tags
                          collapse-tags-tooltip
                          :max-collapse-tags="1"
                          @change="handleCurrentChange(1)"
                        >
                          <el-option
                            v-for="category in exceptionCategoriesMap"
                            :key="category"
                            :label="category"
                            :value="category"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'platform'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="testgo_order_type"
                          placeholder="Platform"
                          clearable
                          multiple
                          collapse-tags
                          collapse-tags-tooltip
                          :max-collapse-tags="1"
                          filterable
                          default-first-option
                          :reserve-keyword="false"
                          @change="handleCurrentChange(1)"
                        >
                          <el-option
                            v-for="platform in platformCategoriesMap"
                            :key="platform"
                            :label="platform"
                            :value="platform"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'priority'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="priority"
                          placeholder="Priority"
                          filterable
                          :clearable="true"
                          default-first-option
                          :reserve-keyword="false"
                          @change="handleCurrentChange(1)"
                        >
                          <el-option
                            v-for="priority in casePriorityTypes"
                            :key="priority"
                            :label="priority.name"
                            :value="priority.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'tat'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="tat_colour"
                          placeholder="TAT"
                          filterable
                          :clearable="true"
                          multiple
                          collapse-tags
                          collapse-tags-tooltip
                          :max-collapse-tags="1"
                          default-first-option
                          :reserve-keyword="false"
                          @change="handleCurrentChange(1)"
                        >
                          <el-option
                            v-for="tat in caseTatTypes"
                            :key="tat"
                            :label="tat.name"
                            :value="tat.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'inhouse_sendout'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="caseSourceFilter"
                          placeholder="Inhouse/Sendout"
                          filterable
                          :clearable="true"
                          default-first-option
                          :reserve-keyword="false"
                          @change="handleCurrentChange(1)"
                        >
                          <el-option label="In-house Lab" value="inhouse"></el-option>
                          <el-option label="Sendout" value="sendout"></el-option>
                        </el-select>
                      </div>
                    </template>
                    <template v-else-if="element.key === 'houston_only'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="houstonOnlyCases"
                          placeholder="Only Houston Cases"
                          filterable
                          :clearable="true"
                          default-first-option
                          :reserve-keyword="false"
                          @change="handleCurrentChange(1)"
                        >
                          <el-option label="YES" value="YES"></el-option>
                          <el-option label="NO" value="NO"></el-option>
                        </el-select>
                      </div>
                    </template>
                  </li>
                </template>
              </draggable>
            </el-col>
          </el-row>
          </transition>
        </div>
      </div>
    </div>
    <div class="container-default" style="padding-top: 0">
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="displayedCases"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
            @selection-change="handleSelectionChange($event)"
            :row-class-name="tableRowClassName"
          >
            <el-table-column
              type="selection"
              width="40"
              class="selection-check"
            ></el-table-column>
            <el-table-column
              fixed="left"
              width="35"
              v-if="isFacilityUser || isUserLab"
            >
              <template #default="scope">
                <span
                  v-if="
                    scope.row.is_critical &&
                    scope.row.is_abnormal &&
                    scope.row.test_reports &&
                    scope.row.test_reports.length
                  "
                >
                  <img
                    src="@/assets/images/red-alert-icon.svg"
                    style="width: 16px; margin-top: 7px"
                    alt="icon"
                    title="Contains critical values"
                  />
                </span>
                <span
                  v-else-if="
                    scope.row.is_critical &&
                    scope.row.test_reports &&
                    scope.row.test_reports.length
                  "
                >
                  <img
                    src="@/assets/images/red-alert-icon.svg"
                    style="width: 16px; margin-top: 7px"
                    alt="icon"
                    title="Contains critical values"
                  />
                </span>
                <span
                  v-else-if="
                    scope.row.is_abnormal &&
                    scope.row.test_reports &&
                    scope.row.test_reports.length
                  "
                >
                  <img
                    src="@/assets/images/orange-alert-icon.svg"
                    style="width: 16px; margin-top: 7px; margin-left: -5px"
                    alt="icon"
                    title="Contains abnormal values"
                  />
                </span>
              </template>
            </el-table-column>
            <el-table-column
              fixed="left"
              prop="accession_id"
              label="ACCESSION ID"
              min-width="150"
              sortable="custom"
            >
              <template #default="scope">
                <div class="name-accession" style="display: flex; align-items: center;">
                  <span 
                    v-if="selectedFaxFlag && scope.row.fax_retry_count > 0"
                    class="fax-retry-badge"
                    :title="'Fax failed ' + scope.row.fax_retry_count + ' time(s)'"
                  >
                    {{ scope.row.fax_retry_count }}
                  </span>
                  <span
                    id="accession-id"
                    @click="goToCaseView(scope.row._id)"
                    style="margin-right: 2px"
                  >
                    {{ scope.row.accession_id }}
                    <span
                      v-if="isUserLab"
                      :style="
                        scope.row.Priority === 'STAT'
                          ? 'color: red; font-weight: 600;'
                          : ''
                      "
                    >
                      {{
                        scope.row.Priority === "STAT"
                          ? "- " + scope.row.Priority
                          : ""
                      }}
                    </span>
                  </span>
                </div>
                <!-- Finalisation held (or no longer held) for an open insurance exception. -->
                <span
                  v-if="scope.row.insurance_hold"
                  class="insurance-hold-pill"
                  :class="{
                    'is-on-hold': scope.row.insurance_hold.state === 'ON_HOLD',
                  }"
                  :title="insuranceHoldTitle(scope.row.insurance_hold)"
                >
                  <i class="insurance-hold-dot"></i>
                  <span>{{ insuranceHoldLabel(scope.row.insurance_hold) }}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="TAT" width="130" v-if="isUserLab && !isChantillyLab">
              <template #default="scope">
                <div style="display: flex; align-items: center">
                  <img
                    class="action-active"
                    src="@/assets/images/icons/cases/clock-file.svg"
                    alt="icon"
                    style="margin-right: 8px"
                  />
                  <div v-if="scope.row && scope.row.turn_around_time">
                    <span :style="{ color: scope.row.tat_colour }">
                      {{ scope.row.turn_around_time }}
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Platform"
              prop="testgo_order_type"
              min-width="150"
              fixed="left"
            >
              <template #default="scope">
                <div
                  class="column-status"
                >
                  <div class="date pr-10">
                    <el-tag :type="getPlatFormStatusType(scope?.row?.testgo_order_type)">
                      {{ scope.row.testgo_order_type || "OLD" }}
                    </el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              prop="case_types"
              min-width="135px"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}

                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                        >
                          {{ caseType }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div
                  v-else-if="
                    scope.row.case_types && scope.row.case_types.length == 1
                  "
                  class="case-type"
                >
                  <span class="case-data-type">
                    {{ getCaseTypes(scope.row.case_types)[0] }}
                  </span>
                </div>
                <div v-else></div>
              </template>
            </el-table-column>
            <el-table-column
              prop="patient_info.first_name"
              label="PATIENT NAME"
              min-width="140"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  "
                  @click="
                    copyTitle(getPatientNameByInfo(scope.row.patient_info))
                  "
                >
                  <span class="text-center ordering_facility-value">{{
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Patient DOB" min-width="100">
              <template #default="scope">
                <span style="cursor: default" v-if="scope.row.patient_info">
                  {{
                    scope.row.patient_info.date_of_birth
                      ? formatDate(scope.row.patient_info.date_of_birth)
                      : ""
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="ordering_facility"
              label="ORDERING FACILITIES"
              min-width="215"
              class="ordering_facility"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="scope.row.actual_hospital_name || (scope.row.hospital ? scope.row.hospital.name : '--')"
                >
                  <span class="text-center ordering_facility-value">{{
                    scope.row.hospital ? scope.row.hospital.name : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              v-if="selectedFaxFlag"
              label="FAX NUMBER"
              min-width="140"
            >
              <template #default="scope">
                <span v-if="scope.row.hospital && scope.row.hospital.fax">
                  {{ scope.row.hospital.fax }}
                </span>
                <span v-else class="text-muted">--</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="priorityFlag"
              label="Priority Reason"
              min-width="220"
              class-name="priority-reason-col"
            >
              <!-- <template #default="scope">
                <el-tooltip
                  v-if="scope.row.priority_reason"
                  effect="dark"
                  placement="top"
                  :content="scope.row.priority_reason"
                >
                  <div class="priority-reason-pill">
                    <el-icon class="priority-reason-star"><StarFilled /></el-icon>
                    <span class="priority-reason-text">{{ scope.row.priority_reason }}</span>
                  </div>
                </el-tooltip>
                <span v-else class="text-muted">--</span>
              </template> -->
              <template #default="{ row }">
                <div class="name-accession cursor">
                  <el-tooltip
                    v-if="row.priority_reason"
                    effect="dark"
                    placement="top"
                  >
                    <template #content>
                      {{ row.priority_reason }}
                    </template>
                    <span id="accession-id-blue" class="truncate-text">
                      {{ row.priority_reason }}
                    </span>
                  </el-tooltip>
                  <span v-else>--</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="insuranceExceptionFlag"
              label="Insurance Exception Reason"
              min-width="260"
            >
              <template #default="{ row }">
                <div class="name-accession cursor">
                  <el-tooltip
                    v-if="row.insurance_exception_reason"
                    effect="dark"
                    placement="top"
                  >
                    <template #content>
                      {{ row.insurance_exception_reason }}
                    </template>
                    <span id="accession-id-blue" class="truncate-text">
                      {{ row.insurance_exception_reason }}
                    </span>
                  </el-tooltip>
                  <span v-else>--</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Physician" min-width="120">
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    /* scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes('Dr')
                        ? scope.row.ordering_physician.name
                        : 'Dr ' + scope.row.ordering_physician.name
                      : '--' */
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name
                      : '--'
                  "
                >
                  <span class="ordering_physician-value">
                    {{
                      /* scope.row.ordering_physician
                        ? scope.row.ordering_physician.name.includes("Dr")
                          ? scope.row.ordering_physician.name
                          : "Dr " + scope.row.ordering_physician.name
                        : "--" */
                      scope.row.ordering_physician
                        ? scope.row.ordering_physician.name
                        : "--"
                    }}
                  </span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="Collected On"
              min-width="135"
              prop="collection_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.collection_date" class="d-flex">
                  <div style="cursor: default" class="date pr-10">
                    {{
                      momentWithTimezone(
                        scope.row.collection_date,
                        "MM-DD-yyyy"
                      )
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Received On"
              min-width="125"
              prop="received_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.received_date" class="d-flex">
                  <div style="cursor: default" class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.received_date, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="samplesReceivedTab"
              label="SAMPLES RECEIVED"
              min-width="140"
            >
              <template #default="scope">
                <el-tag
                  v-if="scope.row.samples_received"
                  :type="'success'"
                >
                  RECEIVED
                </el-tag>
                <el-tag v-else :type="'warning'">
                  NOT RECEIVED
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Status"
              width="130"
              sortable="custom"
              prop="status"
            >
              <template v-slot="scope">
                <div class="column-status cursor" v-if="scope.row.status">
                  <el-dropdown
                    class="status-dropdown"
                    @command="
                      (command) =>
                        changeStatus(command, scope.row, scope.$index)
                    "
                    @visible-change="(v) => v && loadPanelDataForRow(scope.row)"
                    trigger="hover"
                    v-if="
                      hasPermission('cases', 'update_status') &&
                      scope.row.status &&
                      scope.row.status != 'ARCHIVED'
                    "
                    :disabled="scope.row.status === 'ARCHIVED'"
                  >
                    <span class="el-dropdown-link">
                      <el-tag :type="getStatusType(scope.row.status)">
                        {{
                          scope.row.status === "COMPLETE"
                            ? "FINALIZED"
                            : scope.row.status === "TEST_REPORTS"
                            ? "PROCESSING"
                            : scope.row.status.split("_").join(" ")
                        }}
                      </el-tag>
                    </span>

                    <template
                      #dropdown
                      v-if="scope.row.status && scope.row.status == 'REJECTED'"
                    >
                      <el-dropdown-menu class="status-dropdown-menu">
                        <el-dropdown-item
                          command="ACTIVE"
                          :disabled="scope.row.status === 'ACTIVE'"
                          >ACTIVE</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="REJECTED"
                          :disabled="scope.row.status === 'REJECTED'"
                        >
                          REJECTED
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                    <template
                      #dropdown
                      v-else-if="
                        scope.row.status &&
                        (scope.row.status == 'COMPLETE' ||
                          scope.row.status == 'TEST_REPORTS')
                      "
                    >
                      <el-dropdown-menu class="status-dropdown-menu">
                        <el-dropdown-item
                          command="TEST_REPORTS"
                          :disabled="scope.row.status === 'TEST_REPORTS'"
                          >PROCESSING</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="COMPLETE"
                          :disabled="scope.row.status === 'COMPLETE'"
                          >FINALIZED</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-if="
                            !scope.row.case_types.includes('CLINICAL_CHEMISTRY')
                          "
                          command="REJECTED"
                          :disabled="scope.row.status === 'REJECTED'"
                        >
                          REJECTED
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="
                            scope.row.case_types.includes(
                              'CLINICAL_CHEMISTRY'
                            ) &&
                            !hasMoreThanOneUniqueCategoryCode(
                              panelDataCache[scope.row._id]
                            )
                          "
                          command="NOT_TO_CALL"
                          :disabled="scope.row.status === 'REJECTED'"
                        >
                          <span
                            class="view-button"
                            title="Reject"
                            @click="openRejectOptions(scope.row, scope.$index)"
                          >
                            REJECTED
                          </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="
                            scope.row.case_types.includes(
                              'CLINICAL_CHEMISTRY'
                            ) &&
                            hasMoreThanOneUniqueCategoryCode(
                              panelDataCache[scope.row._id]
                            )
                          "
                          command="NOT_TO_CALL"
                        >
                          <span
                            class="view-button"
                            title="Reject"
                            @click="openRejectOptions(scope.row, scope.$index)"
                          >
                            REJECTED
                          </span>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                    <template
                      #dropdown
                      v-else-if="
                        scope.row.status &&
                        (scope.row.status == 'ACTIVE' ||
                          scope.row.status == 'INITIATE')
                      "
                    >
                      <el-dropdown-menu class="status-dropdown-menu">
                        <!-- For non-CLINICAL_CHEMISTRY case types -->
                        <el-dropdown-item
                          v-if="
                            !scope.row.case_types.includes('CLINICAL_CHEMISTRY')
                          "
                          command="REJECTED"
                          :disabled="scope.row.status === 'REJECTED'"
                        >
                          REJECTED
                        </el-dropdown-item>

                        <!-- For CLINICAL_CHEMISTRY with 1 category -->
                        <el-dropdown-item
                          v-if="
                            scope.row.case_types.includes(
                              'CLINICAL_CHEMISTRY'
                            ) &&
                            scope.row.status !== 'REJECTED' &&
                            !hasMoreThanOneUniqueCategoryCode(
                              panelDataCache[scope.row._id]
                            )
                          "
                          command="NOT_TO_CALL"
                          :disabled="scope.row.status === 'REJECTED'"
                        >
                          <span
                            class="view-button"
                            title="Reject"
                            @click="openRejectOptions(scope.row, scope.$index)"
                          >
                            REJECTED
                          </span>
                        </el-dropdown-item>

                        <!-- For CLINICAL_CHEMISTRY with > 1 category -->
                        <el-dropdown-item
                          v-if="
                            scope.row.case_types.includes(
                              'CLINICAL_CHEMISTRY'
                            ) &&
                            scope.row.status !== 'REJECTED' &&
                            hasMoreThanOneUniqueCategoryCode(
                              panelDataCache[scope.row._id]
                            )
                          "
                          command="NOT_TO_CALL"
                        >
                          <span
                            class="view-button"
                            title="Reject"
                            @click="openRejectOptions(scope.row, scope.$index)"
                          >
                            REJECTED
                          </span>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>

                  <el-tag
                    v-else-if="isFacilityUser"
                    :type="getStatusType(scope.row.status)"
                  >
                    {{
                        scope.row.status === "TEST_REPORTS"
                        ? "PROCESSING"
                        : scope.row.status === "COMPLETE"
                        ? "FINALIZED"
                        : scope.row.status === "ARCHIVED"
                        ? "ARCHIVED"
                        : scope.row.status === "ACTIVE"
                        ? "ACTIVE"
                        : scope.row.status === "REJECTED"
                        ? "REJECTED"
                        : scope.row.status === "TEST_REPORTS"
                        ? "ACTIVE"
                        : "PROCESSING"
                    }}</el-tag
                  >
                  <el-tag v-else :type="getStatusType(scope.row.status)">
                    <span v-if="scope.row.status === 'TEST_REPORTS'"
                      >PROCESSING</span
                    >
                    <span v-else-if="scope.row.status === 'COMPLETE'"
                      >FINALIZED</span
                    >
                    <span v-else>{{
                      scope.row.status.split("_").join(" ")
                    }}</span>
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Issue Reasons"
              min-width="200"
              v-if="issues === true"
            >
              <template #default="scope">
                <div class="name-accession cursor">
                  <span
                    id="accession-id-blue"
                    :title="
                      scope.row.issues && scope.row.issues.length
                        ? scope.row.issues.join(', ')
                        : '--'
                    "
                  >
                    {{
                      scope.row.issues && scope.row.issues.length
                        ? scope.row.issues.join(", ")
                        : "--"
                    }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="REJECTED REASONS"
              width="300"
              v-if="$route.path === '/all-cases/rejected'"
            >
              <template #default="{ row }">
                <div class="name-accession cursor">
                  <el-tooltip
                    v-if="row.reasons && row.reasons.length > 0"
                    effect="dark"
                    placement="top"
                  >
                    <template #content>
                      {{ row.reasons.join(", ") }}
                    </template>
                    <span id="accession-id-blue" class="truncate-text">
                      {{ row.reasons.join(", ") }}
                    </span>
                  </el-tooltip>
                  <span v-else>--</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="REASON FOR HOLD"
              width="300"
              v-if="this.$route.path === '/all-cases/release-pending'"
            >
              <template #default="scope">
                <div class="name-accession cursor">
                  <el-tooltip
                    placement="bottom"
                    :content="
                      scope.row.release_notes
                        ? scope.row.release_notes.includes(
                            'No payable codes found for case type'
                          )
                          ? scope.row.release_notes.replace(
                              'No payable codes found for case type',
                              'Un-related ICD codes for'
                            )
                          : scope.row.release_notes
                        : ''
                    "
                  >
                    <span id="accession-id-blue">
                      {{
                        scope.row.release_notes
                          ? scope.row.release_notes.includes(
                              "No payable codes found for case type"
                            )
                            ? scope.row.release_notes.replace(
                                "No payable codes found for case type",
                                "Un-related ICD codes for"
                              )
                            : scope.row.release_notes
                          : "--"
                      }}
                    </span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Reported On"
              min-width="125"
              prop="reported_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.reported_at" class="d-flex">
                  <div style="cursor: default" class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.reported_at, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Order/EMR/PHLEBIO" width="180">
              <template #default="scope">
                <div
                  class="name-accession cursor"
                  v-if="scope.row && scope.row.order_id"
                >
                  <span
                    id="accession-id-blue"
                    @click="sendParameter(scope.row)"
                  >
                    {{ scope.row.order_id }}
                  </span>
                </div>
                <div
                  class="name-accession cursor"
                  v-if="scope.row && scope.row.testgo_order_id"
                >
                  <span
                    id="accession-id-blue"
                    @click="sendParameter(scope.row)"
                  >
                    {{ scope.row.testgo_order_id }}
                  </span>
                </div>
                <div
                  class="name-accession cursor"
                  v-if="scope.row && scope.row.emr_order"
                >
                  <span
                    id="accession-id-blue"
                    @click="viewEMR(scope.row.emr_order)"
                  >
                    {{ scope.row.emr_reference_id }}
                  </span>
                </div>
                <!-- <div
                  class="name-accession cursor"
                  v-if="
                    scope.row &&
                    scope.row.phlebio_order_id &&
                    scope.row.phlebio_order_id.Phlebio_Order_id
                  "
                >
                  <span
                    id="accession-id-blue"
                    @click="viewPhlebioOrder(scope.row.phlebio_order_id._id)"
                  >
                    {{ scope.row.phlebio_order_id.Phlebio_Order_id }}
                  </span>
                </div> -->
              </template>
            </el-table-column>
            <el-table-column
              label="Results"
              width="180"
              v-if="hasToxicologyCaseType || showToxColumn"
            >
              <template #default="scope">
                <div
                  class="column-status"
                  v-if="scope.row.status == 'COMPLETE'"
                >
                  <div class="date pr-10">
                    <el-tag :type="getCovidStatusType(resultStatus(scope.row))">
                      {{ resultStatus(scope.row) }}
                    </el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="LABDAQ ORDER STATUS"
              min-width="180"
              prop="reported_at"
              v-if="
                !isFacilityUser &&
                checkLab &&
                (hasClinicalChemistry || showClinicalColumn)
              "
            >
              <template v-slot="scope">
                <el-button
                  type="text"
                  class="btn-synced cursor-test"
                  v-if="scope.row.labdaq_order_status"
                >
                  {{ scope.row.labdaq_order_status }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="LABDAQ REPORT STATUS"
              min-width="210"
              prop="reported_at"
              v-if="
                !isFacilityUser &&
                checkLab &&
                (hasClinicalChemistry || showClinicalColumn)
              "
            >
              <template v-slot="scope">
                <el-button
                  v-if="
                    hasBloodCaseType(scope.row) &&
                    scope.row.labdaq_order_status == 'SENT' &&
                    scope.row.labdaq_report_status == 'PENDING'
                  "
                  type="text"
                  class="btn-sync"
                  @click="syncLabdaqReports(scope.row._id)"
                  >Sync</el-button
                >
                <el-button
                  type="text"
                  class="btn-processing"
                  v-if="
                    scope.row.labdaq_order_status == 'SENT' &&
                    scope.row.labdaq_report_status == 'ERROR'
                  "
                  @click="syncLabdaqReports(scope.row._id)"
                  >Re-Sync</el-button
                >
                <span v-else>
                  <el-button
                    type="text"
                    class="btn-synced cursor-test"
                    v-if="
                      hasBloodCaseType(scope.row) &&
                      scope.row.labdaq_order_status == 'SENT' &&
                      scope.row.labdaq_report_status == 'SYNCED'
                    "
                  >
                    SYNCED
                  </el-button>
                </span>
                <span>
                  <el-button
                    type="text"
                    class="view-button"
                    v-if="
                      hasBloodCaseType(scope.row) &&
                      scope.row.status === 'TEST_REPORTS' &&
                      scope.row.labdaq_report_status == 'SYNCED'
                    "
                    @click="syncLabdaqReports(scope.row._id)"
                  >
                    <img
                      class="action-active"
                      src="@/assets/img/icons/regenerate.svg"
                      alt="icon"
                    />
                  </el-button>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="LABDAQ REPORT MESSAGE"
              min-width="210"
              prop="reported_at"
              v-if="
                !isFacilityUser &&
                checkLab &&
                (hasClinicalChemistry || showClinicalColumn)
              "
            >
              <template v-slot="scope">
                <span>{{ scope.row.labdaq_report_message }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="Results"
              prop="covid_status"
              sortable="custom"
              width="150"
              v-if="hasCovidCaseType || hasCovidColumns"
            >
              <template v-slot="scope">
                <div class="column-status">
                  <el-dropdown
                    v-if="
                      hasCovid(scope.row) &&
                      scope.row.covid_status &&
                      hasPermission('cases', 'update_covid_status')
                    "
                    class="status-dropdown"
                    @command="
                      (command) =>
                        changeCovidStatus(
                          command,
                          scope.row._id,
                          scope.$index,
                          scope.row.covid_status
                        )
                    "
                    trigger="click"
                  >
                    <span class="el-dropdown-link">
                      <el-tag
                        v-if="scope.row.covid_status != 'RESULT_AWAITED'"
                        :type="getCovidStatusType(scope.row.covid_status)"
                      >
                        {{ scope.row.covid_status }}
                      </el-tag>
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu class="status-dropdown-menu">
                        <el-dropdown-item command="POSITIVE"
                          >POSITIVE</el-dropdown-item
                        >
                        <el-dropdown-item command="NEGATIVE"
                          >NEGATIVE</el-dropdown-item
                        >
                        <el-dropdown-item command="INCONCLUSIVE"
                          >INCONCLUSIVE</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>

                  <span
                    v-else-if="hasCovid(scope.row) && scope.row.covid_status"
                  >
                    <el-tag
                      v-if="
                        scope.row.covid_status &&
                        scope.row.covid_status != 'RESULT_AWAITED'
                      "
                      :type="getCovidStatusType(scope.row.covid_status)"
                    >
                      {{ scope.row.covid_status }}
                    </el-tag>
                  </span>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column
              label="Results"
              width="180"
              v-if="hasUtiRppCase || showResultColumn"
            >
              <template #default="scope">
                <div
                  class="column-status"
                  v-if="scope.row.status == 'COMPLETE'"
                >
                  <div class="date pr-10">
                    <el-tag
                      :type="getCovidStatusType(reportResultStatus(scope.row))"
                    >
                      {{ reportResultStatus(scope.row) }}
                    </el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="ARCHIVE REASON"
              width="300"
              v-if="
                hasPermission('cases', 'attachments') &&
                this.$route.path === '/all-cases/archive'
              "
            >
              <template #default="scope">
                <div class="name-accession cursor">
                  <span id="accession-id-blue">
                    {{
                      scope.row.archive_reason ? scope.row.archive_reason : "--"
                    }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              :width="isSuperAdmin ? '245' : '235'"
              fixed="right"
            >
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li @click="goToCaseView(scope.row._id)">
                    <el-button class="view-button" title="View Case">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="(isFacilityUser || isUserLab) && getLatestRerunNote(scope.row)"
                  >
                    <el-tooltip
                      effect="dark"
                      placement="top"
                      :show-after="100"
                    >
                      <template #content>
                        <div><strong>Rerun</strong></div>
                        <div>
                          Added by:
                          {{ getLatestRerunNote(scope.row).added_by_name || "--" }}
                        </div>
                        <div>
                          Added at:
                          {{
                            getLatestRerunNote(scope.row).added_at
                              ? momentWithTimezoneTime(
                                  getLatestRerunNote(scope.row).added_at
                                )
                              : "--"
                          }}
                        </div>
                      </template>
                      <span class="rerun-icon">
                        <el-icon><RefreshRight /></el-icon>
                      </span>
                    </el-tooltip>
                  </li>
                  <li v-if="scope.row.sample_approval_data && scope.row.sample_approval_data.length > 0">
                    <el-tooltip
                      :content="'Use Previous Order Sample: ' + scope.row.sample_approval_data.map(s => s.order_id).join(', ')"
                      placement="top"
                    >
                      <img
                        style="height: 18px; width: 18px; cursor: default;"
                        src="@/assets/images/icons/actions/re-order-active.svg"
                        alt="previous-order-sample"
                      />
                    </el-tooltip>
                  </li>
                  <li
                    @click="onRestore(scope.row._id)"
                    v-if="scope.row.status == 'ARCHIVED' && hasPermission('restore', 'create')"
                  >
                    <el-button class="view-button" title="Restore">
                      <img
                        class="action-active"
                        src="@/assets/img/icons/regenerate.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/img/icons/regenerate.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status == 'ACTIVE' &&
                      hasPermission('send_outs', 'create') &&
                      !this.validationStatus
                    "
                  >
                    <el-button
                      class="reports-button"
                      @click="goToSendOutReports(scope.row._id)"
                      :disabled="checkSendOutDisable(scope.row)"
                      :title="
                        checkSendOutDisable(scope.row)
                          ? 'Sendout Already Created'
                          : 'Sendout'
                      "
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/sendouts-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/sendouts-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status != 'ARCHIVED' &&
                      hasPermission('cases', 'delete') &&
                      scope.row.status == 'ACTIVE' &&
                      !this.validationStatus
                    "
                  >
                    <el-button
                      title="Archive"
                      class="delete-button"
                      @click="onDelete(scope.row._id)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/archive-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/archive-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.is_labdaq_order == true &&
                      scope.row.status !== 'COMPLETE' &&
                      scope.row.status !== 'ARCHIVED' &&
                      scope.row.case_types &&
                      scope.row.case_types.indexOf('CLINICAL_CHEMISTRY') !==
                        -1 &&
                      hasPermission('cases', 'create_case') &&
                      !isFacilityUser &&
                      checkLab && !this.validationStatus
                    "
                  >
                    <el-button
                      v-if="scope.row.labdaq_order_status == 'SENT'"
                      title="Resend To Labdaq"
                      class="delete-button"
                      @click="sentToLabdaq(scope.row._id)"
                    >
                      <img
                        class="inactive"
                        src="@/assets/images/resend-order.svg"
                        alt="icon"
                      />
                    </el-button>
                    <el-button
                      v-else
                      title="Send To Labdaq"
                      class="delete-button"
                      @click="sentToLabdaq(scope.row._id)"
                    >
                      <img
                        class="inactive"
                        src="@/assets/images/send-order.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status != 'ARCHIVED' &&
                      scope.row.status == 'COMPLETE' &&
                      (isFacilityUser || hasPermission('cases', 'create_case')) && 
                      !this.validationStatus
                    "
                  >
                    <el-button
                      title="View Report"
                      class="reports-button"
                      @click="onViewReports(scope.row)"
                    >
                      <span
                        class="beforeTestReportsIcon"
                        v-if="
                          checkNewReport(scope.row) &&
                          checkCaseStatus(scope.row)
                        "
                      >
                        <img
                          src="@/assets/images/icons/actions/beforeViewIcon.svg"
                          alt="icon"
                          style="width: 18px"
                        />
                      </span>
                      <span class="afterTestReportsIcon" v-else>
                        <img
                          src="@/assets/images/icons/actions/afterViewIcon.svg"
                          alt="icon"
                          style="width: 18px"
                        />
                      </span>
                    </el-button>
                  </li>
                  <!-- <li
                    v-else-if="
                      scope.row.status != 'ARCHIVED' &&
                      scope.row.priliminary_report_generated == true &&
                      hasPermission('cases', 'preliminary_report') && !this.validationStatus
                    "
                  >
                    <el-button
                      title="View Report"
                      class="reports-button"
                      @click="onViewPriliminaryReports(scope.row)"
                    >
                      <span
                        class="beforeTestReportsIcon"
                        v-if="scope.row.priliminary_report_viewed == false"
                      >
                        <img
                          src="@/assets/images/icons/actions/beforeViewIcon.svg"
                          alt="icon"
                          style="width: 18px"
                        />
                      </span>
                      <span class="afterTestReportsIcon" v-else>
                        <img
                          src="@/assets/images/icons/actions/afterViewIcon.svg"
                          alt="icon"
                          style="width: 18px"
                        />
                      </span>
                    </el-button>
                  </li> -->
                  <li v-if="hasPermission('cases', 'archive_cases') && !this.validationStatus">
                    <el-button
                      title="Move To Validation"
                      class="reports-button validation-button"
                      @click="moveToValidations(scope.row._id)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/validation-new-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/validation-new-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status != 'ARCHIVED' &&
                      hasPermission('cases', 'archive_cases') && !this.validationStatus
                    "
                  >
                    <el-button
                      title="Archive"
                      class="delete-button"
                      @click="onDelete(scope.row._id)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/archive-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/archive-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    @click="gotoPatientResultsTrendToxiclogy(scope.row)"
                    v-if="
                      scope.row.status == 'COMPLETE' &&
                      scope.row.case_types &&
                      scope.row.case_types[0] == 'TOXICOLOGY' &&
                      !this.validationStatus
                    "
                  >
                    <el-button class="view-button" title="PATIENT RESULTS">
                      <img
                        src="@/assets/images/icons/actions/trends-icon-new.svg"
                        alt="icon"
                        style="width: 18px"
                      />
                    </el-button>
                  </li>
                  <li
                    @click="gotoPatientResultsTrendClinicalChemistry(scope.row)"
                    v-if="
                      scope.row.status == 'COMPLETE' &&
                      scope.row.case_types &&
                      scope.row.case_types[0] == 'CLINICAL_CHEMISTRY' &&
                      checkColonyLab && !this.validationStatus
                    "
                  >
                    <el-button class="view-button" title="PATIENT RESULTS">
                      <img
                        src="@/assets/images/icons/actions/trends-icon-new.svg"
                        alt="icon"
                        style="width: 18px"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      isResultPositive(scope.row) &&
                      scope.row.status == 'COMPLETE' &&
                      scope.row.case_types[0] == 'UTI' &&
                      hasPermission('cases', 'report_upload_new') &&
                      isAbletoGeneratePathologyReport
                    "
                  >
                    <el-button
                      class="action-download"
                      @click="generatePathologyReport(scope.row)"
                      title="Generate Pathology Report"
                    >
                      <span>
                        <img
                          src="@/assets/images/icons/actions/restore-icon.svg"
                          alt="icon"
                          class="img-fluid"
                        />
                      </span>
                    </el-button>
                  </li>
                  <li
                    @click="acknowledgeTat(scope.row)"
                    v-if="$route.name == 'TatCrossedCases'"
                  >
                    <el-button
                      class="view-button"
                      title="TAT ACKNOWLEDGE"
                    >
                     TA
                    </el-button>
                  </li>
                  <li
                    @click="sampleReceived(scope.row)"
                    v-if="
                      samplesReceivedTab &&
                      !scope.row.samples_received
                    "
                  >
                    <el-button
                      class="view-button"
                      title="MARK SAMPLES RECEIVED"
                    >
                     SR
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[25, 50, 75, 100]"
            layout=" prev, pager, next, jumper, sizes ,total"
            :total="getAllCases.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <div class="default-modal">
      <div v-if="generateBarcodesDialogVisible">
        <el-dialog
          top="10%"
          width="35%"
          v-model="generateBarcodesDialogVisible"
        >
          <div class="dialog-header">
            <span class="header-part">
              <img
                src="@/assets/images/new-barcode-icon-blue.svg"
                alt="icon"
              />Generate Barcodes
            </span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="generateBarcodesDialogVisible = false"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>

          <el-row :gutter="20" class="popup-date">
            <el-col :lg="8" :xl="9">
              <span class="date-label">From Date</span>
              <el-date-picker
                type="date"
                v-model="barcode_receive_from_date"
                placeholder="From Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="9">
              <span class="date-label">To Date</span>
              <el-date-picker
                type="date"
                v-model="barcode_receive_to_date"
                placeholder="To Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="6">
              <div class="dialog-footer mt-15">
                <el-button
                  class="blue-save-button"
                  @click="onSelectedDatesGenerateBarcodes"
                  :disabled="isDateAvailable"
                >
                  GENERATE</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-dialog>
      </div>
    </div>
    <!-- Select Tests to Reject popup -->
    <TestsRejectPopup
      :showRejectTestPopup="showRejectTestPopup"
      :groupedTests="groupedTests"
      :selectedTests="selectedTests"
      :selectedPanels="selectedPanels"
      :formData="formData"
      :loading="loading"
      :rejectCaseError="rejectCaseError"
      :isRejectButtonDisabled="isRejectButtonDisabled"
      :predefinedReasons="predefinedReasons"
      @close-popup="closeIconRejectPopup"
      @update-individual-test="updateIndividualTest"
      @select-panel-tests="selectPanelTests"
      @update-reasons="(val) => (formData.selectedReasons = val)"
      @update-notes="updateNotes"
      @update-image="updateRejectImage"
      @form-validated="rejectSelectedTests"
    />

    <!-- Reject Options Popup for Clinical Chemistry -->
    <OptionsRejectPopup
      :visible="showRejectOptionsPopup"
      @close="showRejectOptionsPopup = false"
      @partial="onPartialRejectOption"
      @complete="onCompleteRejectOption"
    />

    <div class="default-modal">
      <div v-if="generateQrcodesDialogVisible">
        <el-dialog top="10%" width="35%" v-model="generateQrcodesDialogVisible">
          <div class="dialog-header">
            <span class="header-part">
              <img
                src="@/assets/images/new-barcode-icon-blue.svg"
                alt="icon"
              />Generate Qrcodes
            </span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="generateQrcodesDialogVisible = false"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>

          <el-row :gutter="20" class="popup-date">
            <el-col :lg="8" :xl="9">
              <span class="date-label">From Date</span>
              <el-date-picker
                type="date"
                v-model="qrcode_receive_from_date"
                placeholder="From Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="9">
              <span class="date-label">To Date</span>
              <el-date-picker
                type="date"
                v-model="qrcode_receive_to_date"
                placeholder="To Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="6">
              <div class="dialog-footer mt-15">
                <el-button
                  class="blue-save-button"
                  @click="onSelectedDatesGenerateQrcodes"
                  :disabled="isQrDateAvailable"
                >
                  GENERATE</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-dialog>
      </div>
    </div>
    <div class="default-modal">
      <el-dialog top="10%" width="35%" v-model="errorMessage">
        <div class="dialog-header">
          <span class="header-part"> Error </span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="errorMessage = false"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="popup-date">
          <h3 class="messageData">{{ this.messageData }}</h3>
        </div>
        <div class="popup-date">
          {{ this.testDetailsData }}
        </div>
      </el-dialog>
    </div>
    <div class="default-modal">
      <div v-if="generateTestBarcodesDialogVisible">
        <el-dialog
          top="10%"
          width="35%"
          v-model="generateTestBarcodesDialogVisible"
        >
          <div class="dialog-header">
            <span class="header-part">
              <img
                src="@/assets/images/new-barcode-icon-blue.svg"
                alt="icon"
              />Generate Barcodes
            </span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="generateTestBarcodesDialogVisible = false"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>

          <el-row :gutter="20" class="popup-date">
            <el-col :lg="8" :xl="9">
              <span class="date-label">From Date</span>
              <el-date-picker
                type="date"
                v-model="test_barcode_receive_from_date"
                placeholder="From Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="9">
              <span class="date-label">To Date</span>
              <el-date-picker
                type="date"
                v-model="test_barcode_receive_to_date"
                placeholder="To Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="6">
              <div class="dialog-footer mt-15">
                <el-button
                  class="blue-save-button"
                  @click="onSelectedDatesGenerateTestBarcodes"
                  :disabled="isTestDateAvailable"
                >
                  GENERATE</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-dialog>
      </div>
      <div v-if="externalLabBarcodesDialogVisible">
        <el-dialog
          top="10%"
          width="35%"
          v-model="externalLabBarcodesDialogVisible"
        >
          <div class="dialog-header">
            <span class="header-part">
              <img
                src="@/assets/images/new-barcode-icon-blue.svg"
                alt="icon"
              />External Lab Barcodes
            </span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="externalLabBarcodesDialogVisible = false"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>

          <el-row :gutter="20" class="popup-date">
            <el-col :span="24">
              <span class="date-label">Labs</span>
              <el-select
                v-model="external_lab_barcode_lab_ids"
                multiple
                filterable
                collapse-tags
                placeholder="Select Labs"
                style="width: 100%"
                :loading="externalLabsLoading"
              >
                <el-option
                  v-for="lab in externalLabOptions"
                  :key="lab._id"
                  :label="lab.name"
                  :value="lab._id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="popup-date">
            <template v-if="!selectedCaseIds.length">
              <el-col :lg="8" :xl="9">
                <span class="date-label">From Date</span>
                <el-date-picker
                  type="date"
                  v-model="external_lab_barcode_from_date"
                  placeholder="From Date"
                  format="MM-DD-YYYY"
                  :disabled-date="disabledDate"
                  value-format="YYYY-MM-DD"
                >
                </el-date-picker>
              </el-col>
              <el-col :lg="8" :xl="9">
                <span class="date-label">To Date</span>
                <el-date-picker
                  type="date"
                  v-model="external_lab_barcode_to_date"
                  placeholder="To Date"
                  format="MM-DD-YYYY"
                  :disabled-date="disabledDate"
                  value-format="YYYY-MM-DD"
                >
                </el-date-picker>
              </el-col>
            </template>
            <el-col :lg="8" :xl="6">
              <div class="dialog-footer mt-15">
                <el-button
                  class="blue-save-button"
                  @click="onGenerateExternalLabBarcodes"
                  :disabled="isExternalLabBarcodeFormIncomplete"
                >
                  GENERATE</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-dialog>
      </div>
    </div>    
    <div class="default-modal">
      <div v-if="tatAcknowledgeDialogVisible">
        <el-dialog
          top="15%"
          width="25%"
          v-model="tatAcknowledgeDialogVisible"
        >
          <div class="dialog-header">
            <span class="header-part">
              Acknowledge Case
            </span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="closeTatPopup()"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>
          <div class="popup-date" style="display: flex;flex-direction: column; row-gap: 10px; ">
          <p style="color: #000000; font-weight: 600;">Accession Id : <span style="font-weight: 400;">{{ this.tatData?.accession_id  }}</span></p>
          <div>
            <p class="date-label">Target TAT * <span style="color: gray">(defaults to +24 hrs from now)</span></p>
            <el-date-picker
              type="datetime"
              v-model="target_tat"
              placeholder="MM-DD-YYYY HH:MM AM"
              format="MM-DD-YYYY hh:mm A"
              :disabled-date="disabledDateTat"
              :clearable="false"
            ></el-date-picker>
          </div>
          <div>
            <span class="date-label">Notes *</span>
            <el-input
              type="textarea"
              v-model="tatReason"
              placeholder="Enter Acknowledgement Notes..."
            >
            </el-input>
          </div>
          </div>
          <div class="dialog-footer">
            <el-button
              class="blue-save-button"
              @click="closeTatPopup()"
            >
              Cancel
            </el-button>
            <el-button
              class="blue-save-button"
              @click="acknowledgeCase"
              :disabled="!tatReason || !tatReason.trim()"
              v-loading="tatLoading"
            > Acknowledge
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
      <div class="default-modal">
      <el-dialog
        v-model="showBulkAcknowledgmentDialog"
        top="8vh"
        width="820px"
        custom-class="bulk-sample-received-dialog"
        :close-on-click-modal="false"
        destroy-on-close
      >
        <template #header>
          <div class="dialog-header-custom">
            <span class="header-title">
              <img
                src="@/assets/images/icons/cases/success-popup-icon.svg"
                alt="icon"
                class="header-icon"
              />
              Confirm Samples Received
            </span>
            <el-button
              class="close-btn"
              text
              @click="showBulkAcknowledgmentDialog = false"
            >
              ✕
            </el-button>
          </div>
        </template>

        <!-- BODY CONTENT -->
        <div class="dialog-body-content">

          <!-- Selection Summary -->
          <div class="selection-summary-card">
            <div class="selection-count-badge">
              {{ selectedCases.length }}
            </div>
            <div class="selection-text">
              <div class="selection-title">
                {{ selectedCases.length }} {{ selectedCases.length === 1 ? 'Case' : 'Cases' }} Selected
              </div>
              <div class="selection-subtitle">
                Review the cases below before marking their samples as received.
              </div>
            </div>
          </div>

          <!-- Cases Table -->
          <div class="cases-table-wrapper">
            <div class="table-label">Selected Cases</div>
            <el-table
              :data="selectedCases"
              max-height="240"
              border
              size="default"
              empty-text="No cases selected"
              class="cases-table"
            >
              <el-table-column
                prop="accession_id"
                label="ACCESSION ID"
                min-width="150"
              >
                <template #default="{ row }">
                  <span class="accession-id-cell">{{ row.accession_id }}</span>
                </template>
              </el-table-column>

              <el-table-column label="CASE TYPE" min-width="140">
                <template #default="{ row }">
                  <span class="case-type-badge">
                    {{ getCaseTypes(row.case_types).join(', ') }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="TEST TUBES" min-width="180">
                <template #default="{ row }">
                  <div
                    v-if="row.test_tube_information && row.test_tube_information.length"
                    class="test-tube-list"
                  >
                    <span
                      v-for="(tube, index) in row.test_tube_information"
                      :key="tube.tube_name || index"
                      class="test-tube-badge"
                    >
                      {{ tube.tube_name }}
                    </span>
                  </div>
                  <span v-else class="empty-tube-cell">--</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- TAT Information -->
          <div class="tat-info-card">
            <div class="tat-info-icon">⏱</div>
            <div class="tat-info-text">
              <div class="tat-info-title">TAT will start after confirmation.</div>
              <div class="tat-info-description">
                Confirming this action acknowledges that the samples have been received by the laboratory. The acknowledgment time will be used as the TAT start time.
              </div>
            </div>
          </div>

        </div>

        <!-- FOOTER -->
        <template #footer>
          <div class="dialog-footer-custom">
            <el-button
              class="btn-cancel"
              plain
              @click="showBulkAcknowledgmentDialog = false"
            >
              CANCEL
            </el-button>
            <el-button
              class="btn-confirm"
              :loading="bulkSampleReceivedLoading"
              :disabled="!selectedCases.length"
              @click="confirmBulkSamplesReceived"
            >
              CONFIRM RECEIPT
            </el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <ExportCases
      v-if="exportReportsDialogVisisble"
      v-on:close="exportReportsDialogVisisble = false"
      :selected_dob="date_of_birth"
      :selected_case_type="caseType"
      :selected_hospital="(selectedHospital || []).map((h) => h && h._id).filter(Boolean)"
      :selected_hospital_names="(selectedHospital || []).map((h) => h && h.name).filter(Boolean)"
      :selected_user="test_performed_by"
      :selected_marketer="hospital_marketer"
      :selected_tests="test_info"
      :selected_physician="physician"
      :selected_string="search_string"
      :selected_emr="emr"
      :selected_accession_id="accession_id"
      :search_case_status="
        crossLabRegistered && crossLabCaseStatus.length
          ? crossLabCaseStatus
          : selectedStatuses
      "
      :search_first_name="patient_name"
      :pregnancy="pregnant"
      :sendout="sendout || caseSourceFilter === 'sendout'"
      :inhouse="searchBy === 'inhouse' || caseSourceFilter === 'inhouse'"
      :cross_lab_registered="exportCrossLabRegistered"
      :emr_not_sent="emr_not_sent"
      :selected_exception="billing_sub_status"
      :replaced_insurance="replaced_insurance"
      :priority="priority"
      :tat_colour="tat_colour"
      :fromDate="fromDate"
      :toDate="toDate"
      :selected_date_type="fromDate || toDate ? dateType : ''"
      :selectedPlatform="testgo_order_type"
      :selectedFaxFlag="selectedFaxFlag"
      :tatNotCrossedFlag="tatNotCrossedFlag"
      :selectedReportStatus="selectedReportStatus"
      :issues="issues"
      :release="releaseFilter"
      :isStatSort="isStatSort"
    >
    </ExportCases>
    <ResonForChange
      v-if="takeReasonDialog"
      v-on:close="takeReasonDialog = false"
      v-on:reasonSubmit="deleteCase"
      title="Reason for Archive"
    ></ResonForChange>
    <ResonForStatusChange
      v-if="takeStatusChangeReasonDialog"
      v-on:close="takeStatusChangeReasonDialog = false"
      v-on:reasonSubmit="unsetCaseCompleteStatus"
      :width="40"
      :title="takeStatusChangeReasonDialogTitle"
    >
    </ResonForStatusChange>
    <ResonForValidation
      v-if="takeValidationReasonDialog"
      v-on:close="takeValidationReasonDialog = false"
      v-on:reasonSubmit="moveToValidation"
      title="Reason for Validation"
    ></ResonForValidation>
    <ReasonForStatusMoving
      v-if="takeStatusMovingReasonDialog"
      v-on:close="takeStatusMovingReasonDialog = false"
      v-on:reasonSubmit="unsetCaseMovingStatus"
      :width="40"
      :title="takeStatusChangeReasonDialogTitle"
    >
    </ReasonForStatusMoving>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
import userConstants from "@/config/constants/userConstants";
import {
  casesExtraSearchOptions,
  exceptionCategories,
} from "@/config/constants/searchConstants";
import {
  predefinedReasons,
  reasonToActionMap,
} from "@/config/constants/rejectionReasons";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import FilterHelper from "@/mixins/FilterHelper";
import SearchShortcutMixin from "@/mixins/SearchShortcutMixin";
import ListRowShortcutsMixin from "@/mixins/ListRowShortcutsMixin";
import AppHelper from "@/mixins/AppHelper";
import axios from "axios";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ResonForStatusChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ExportCases = defineAsyncComponent(() =>
  import("@/components/cases/ExportCases")
);
const ResonForValidation = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ReasonForStatusMoving = defineAsyncComponent(() =>
  import("@/components/misc/OrderReasonForChange")
);
import TestsRejectPopup from "./TestsRejectPopup.vue";
import OptionsRejectPopup from "./OptionsRejectPopup.vue";
import draggable from "vuedraggable";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import config from "@/config/app";
export default {
  name: "allCases",
  components: {
    ResonForChange,
    ResonForStatusChange,
    ExportCases,
    ResonForValidation,
    ReasonForStatusMoving,
    TestsRejectPopup,
    OptionsRejectPopup,
    draggable,
  },
  props: {
    selectedStatuses: {
      default: [],
    },
    issues: {
      type: Boolean,
      default: false,
    },
    selectedReportStatus: {
      default: false,
    },
    emr_not_sent: {
      default: false,
    },
    replaced_insurance: {
      default: false,
    },
    validationStatus:{
      default: false,
    },
    selectedFaxFlag:{
      type: String,
      default : ""
    },
    tatNotCrossedFlag:{
      type: Boolean,
      default : false
    },
    crossLabRegistered:{
      type: Boolean,
      default : false
    },
    priorityFlag:{
      type: Boolean,
      default : false
    },
    insuranceExceptionFlag:{
      type: Boolean,
      default : false
    },
    samplesReceivedTab: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.searchOptions = this.searchOptions.filter((option) => option.active);
  },
  computed: {
    displayedCases() {
      const cases = this.getAllCases && this.getAllCases.data;
      if (!this.samplesReceivedTab || !Array.isArray(cases)) {
        return cases;
      }
      return cases.filter(
        (caseData) =>
          caseData.status === "ACTIVE" && caseData.samples_received === false
      );
    },
    // Reflect the chosen date type in the From/To placeholders so it's clear
    // which date the range filters on (the type is set in Customize Filters).
    dateTypeLabel() {
      const opt = this.dateTypeOptions.find((o) => o.value === this.dateType);
      return opt ? opt.label : "Created On";
    },
    fromDatePlaceholder() {
      return `From (${this.dateTypeLabel})`;
    },
    toDatePlaceholder() {
      return `To (${this.dateTypeLabel})`;
    },
    getPlatFormStatusType() {
      return (statusVal) => {
        const status = statusVal;
        const statusMap = {
          EMR: "default",
          'MEDICAL-GROUP': "success",
          MLX: "warning",
          TESTGO: "info",
        };
        return statusMap[status] || "";
      };
    },
    ...mapGetters("cases", [
      "getUpdateCaseCovidStatus",
      "getCaseDeleteStatus",
      "getUpdateCaseStatus",
      "getRestoreCaseStatus",
      "getSendAccessionToLabdaq",
      "getSyncAccessionToLabdaq",
      "getTestReportsDownloadLog",
      "getTestReportsViewLog",
      "getSendToLabdaqValiationError",
      "getUpdateValidationStatus",
      "getDownloadReportData",
      "getGeneratePathologyReportStatus",
      "getUpdatedTatAcknodgement",
      "getUpdatedSampleReceivedStatus",
      "getUpdatedSampleReceivedBulkStatus"
    ]),
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getUserAllowedLabs",
      "getUserPrimaryLabId",
    ]),
    ...mapGetters("labs", ["getExternalLabs"]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    ...mapGetters("vendors", ["getVendorCodes"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
    releaseFilter() {
      if (this.$route.path === "/all-cases/release-pending") {
        return false;
      }
      if (this.$route.path === "/all-cases/new-reports") {
        return true;
      }
      return "";
    },
    isDateAvailable() {
      if (!this.barcode_receive_to_date) {
        return true;
      }
      return false;
    },
    barcodeMenuOptions() {
      const hasSelection = this.selectedCaseIds.length > 0;
      const options = [
        {
          command: "barcode",
          title: hasSelection ? "Print Barcode" : "Generate Barcode",
          description: "For UTI and Tox instruments",
        },
        {
          command: "qrcode",
          title: hasSelection ? "Print QR Code" : "Generate QR Code",
          description: "For scanning the attachments",
        },
        {
          command: "test",
          title: hasSelection ? "Print Test Barcodes" : "Generate Test Barcodes",
          description: "For custom blood barcode instruments",
          dlwOnly: true,
        },
        {
          command: "external",
          title: "Generate External Lab Barcodes",
          description: "For all Labsquire integrated labs' barcodes",
        },
      ];
      return options.filter((option) => !option.dlwOnly || this.checkDLWLab);
    },
    externalLabOptions() {
      return this.getExternalLabs || [];
    },
    isExternalLabBarcodeFormIncomplete() {
      if (!this.external_lab_barcode_lab_ids.length) {
        return true;
      }
      // Selected cases need no date range.
      if (this.selectedCaseIds.length) {
        return false;
      }
      return (
        !this.external_lab_barcode_from_date ||
        !this.external_lab_barcode_to_date
      );
    },
    isTestDateAvailable() {
      if (!this.test_barcode_receive_to_date) {
        return true;
      }
      return false;
    },
    isQrDateAvailable() {
      if (!this.qrcode_receive_to_date) {
        return true;
      }
      return false;
    },
    checkCaseStatus() {
      return (caseData) => {
        if (caseData.status === "COMPLETE") {
          return true;
        } else {
          return false;
        }
      };
    },
    checkNewReport() {
      return (caseData) => {
        if (caseData && caseData.test_reports && caseData.test_reports.length) {
          let newReport = caseData.test_reports.find((report) => {
            if (report.download_logs) {
              let userDownloadLog = report.download_logs.find(
                (e) => e.user_id === this.getAuthenticatedUser._id
              );
              if (userDownloadLog) {
                return false;
              } else {
                return true;
              }
            }
          });
          if (newReport) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      };
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else if (status == "REJECTED") {
          return "darkDanger";
        } else if (status == "PENDING") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    getCovidStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else if (status == "CONSISTENT") {
          return "success";
        } else if (status == "INCONSISTENT") {
          return "warning";
        } else {
          return "nullvalue";
        }
      };
    },
    ...mapGetters("cases", ["getAllCases", "getBulkValidations"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("profile", ["getProfileData"]),
    // Whether a filter is applicable for the current user/context (role + conditional guards)
    isFilterAllowed() {
      return (key) => {
        if (key === "test_id") {
          return this.caseType && this.caseType.length === 1;
        }
        // Houston-only toggle is meaningful for TestGo Houston users alone.
        if (key === "houston_only") {
          return this.isHoustonLab;
        }
        return true;
      };
    },
    // Filter metadata arranged in the user's saved order (new filters appended at the end)
    orderedFilterMeta() {
      const metaByKey = {};
      this.allCasesFilterMeta.forEach((f) => (metaByKey[f.key] = f));
      const ordered = [];
      (this.filterOrder || []).forEach((key) => {
        if (metaByKey[key]) ordered.push(metaByKey[key]);
      });
      this.allCasesFilterMeta.forEach((f) => {
        if (!this.filterOrder || this.filterOrder.indexOf(f.key) === -1) {
          ordered.push(f);
        }
      });
      return ordered;
    },
    // The filters actually rendered in the bar (visible = allowed & not hidden), draggable
    orderedVisibleFilters: {
      get() {
        return this.orderedFilterMeta.filter(
          (f) => this.isFilterAllowed(f.key) && !this.hiddenFilters.includes(f.key)
        );
      },
      set(newVisible) {
        const visibleQueue = newVisible.map((f) => f.key);
        const currentOrder = this.orderedFilterMeta.map((f) => f.key);
        const rebuilt = currentOrder.map((key) =>
          this.isFilterAllowed(key) && !this.hiddenFilters.includes(key)
            ? visibleQueue.shift()
            : key
        );
        this.filterOrder = rebuilt;
        this.saveFilterPreferences();
      },
    },
    // Filters offered in the customize panel (only those applicable to this user)
    customizableFilters() {
      return this.orderedFilterMeta.filter((f) => this.isFilterAllowed(f.key));
    },
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    hasCovidCaseType() {
      if (
        this.searchBy == "case_types" &&
        (this.caseType.includes(caseConstants.CASE_TYPE_COVID) || this.caseType.includes(caseConstants.CASE_TYPE_COVID_FLU))
      ) {
        return true;
      }
      if (
        this.$route.query.selectedSearchBy == "case_types" &&
        (this.$route.query.selectedCase == caseConstants.CASE_TYPE_COVID ||
          this.$route.query.selectedCase == caseConstants.CASE_TYPE_COVID_FLU)
      ) {
        return true;
      }
      return false;
    },
    hasToxicologyCaseType() {
      if (this.searchBy == "case_types" && this.caseType.includes(caseConstants.CASE_TYPE_TOXICOLOGY)) {
        return true;
      }
      if (
        this.$route.query.selectedSearchBy == "case_types" &&
        this.$route.query.selectedCase == caseConstants.CASE_TYPE_TOXICOLOGY
      ) {
        return true;
      }
      return false;
    },

    hasUtiRppCase() {
      if (
        this.searchBy == "case_types" &&
        caseConstants.UTI_RPP_CASE_TYPES.some(
          (t) => this.caseType.includes(t)
        )
      ) {
        return true;
      }
      if (
        this.$route.query.selectedSearchBy == "case_types" &&
        caseConstants.UTI_RPP_CASE_TYPES.includes(this.$route.query.selectedCase)
      ) {
        return true;
      }
      return false;
    },
    ...mapGetters("errors", ["getErrors", "getError"]),
    checkDLWLab() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && (matchedLab.lab_code == "DLW-TX" || matchedLab.lab_code == "DLW-HOU" || matchedLab.lab_code == "DLW")) {
          return true;
        }
        return false;
      }
      return false;
    },
    checkLab() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && matchedLab.lab_code == "DLW") {
          return true;
        }
        return false;
      }
      return false;
    },
    // "Only Houston Cases": YES -> the lab's own cases (is_cross_lab_registered
    // false), NO -> the cross-lab (Irving registered) ones. undefined = no filter.
    houstonCrossLabFilter() {
      if (!this.isHoustonLab || !this.houstonOnlyCases) {
        return undefined;
      }
      return this.houstonOnlyCases !== "YES";
    },
    // The cross-lab tab has its own list endpoint, but the CSV export hits the
    // generic one, so it always has to ask for the cross-lab cases explicitly.
    exportCrossLabRegistered() {
      return this.crossLabRegistered ? true : this.houstonCrossLabFilter;
    },
    isHoustonLab() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        return !!(matchedLab && matchedLab.lab_code == "DLW-HOU");
      }
      return false;
    },
    reportResultStatus() {
      return (row) => {
        const report = row?.test_reports?.find((r) => r.mark_for_physician);
        return report?.result_status ?? "--";
      };
    },
    resultStatus() {
      return this.reportResultStatus;
    },
    hasClinicalChemistry() {
      if (
        this.searchBy == "case_types" &&
        this.caseType.includes(caseConstants.CASE_TYPE_CLINICAL_CHEMISTRY)
      ) {
        return true;
      }
      if (
        this.$route.query.selectedSearchBy == "case_types" &&
        this.$route.query.selectedCase == caseConstants.CASE_TYPE_CLINICAL_CHEMISTRY
      ) {
        return true;
      }
      return false;
    },
    showClinicalColumn() {
      if (this.search_string && this.getAllCases && this.getAllCases.data) {
        return this.getAllCases.data.every(
          (item) => item.case_types.length === 1 && item.case_types[0] === "CLINICAL_CHEMISTRY"
        );
      }
      return null;
    },
    isResultPositive() {
      return (row) => {
        return row?.test_reports?.some(
          (r) => r.mark_for_physician && r.result_status === "POSITIVE"
        ) ?? false;
      };
    },
    isRejectButtonDisabled() {
      const hasSelectedTests = Object.keys(this.selectedTests).length > 0;
      const hasSelectedPanels = Object.values(this.selectedPanels).some(
        Boolean
      );
      const hasReasons =
        Array.isArray(this.formData.selectedReasons) &&
        this.formData.selectedReasons.length > 0;
      const hasValidNotes =
        typeof this.formData.notes === "string" &&
        this.formData.notes.trim().length >= 3;
      const hasImage = !!this.formData.image;

      // Enable button only if: (tests OR panels selected) AND reasons AND valid notes AND image
      return (
        this.allItemsSelected ||
        !(
          (hasSelectedTests || hasSelectedPanels) &&
          hasReasons &&
          hasValidNotes &&
          hasImage
        )
      );
    },
    totalRejectableItems() {
      // Calculate total rejectable items:
      // - Panels (excluding ALL_TESTS and SEND_OUTS if they exist)
      // - Individual tests in ALL_TESTS and SEND_OUTS if they exist
      const excludedPanels = ["ALL_TESTS", "SEND_OUTS"].filter((panel) =>
        Object.keys(this.groupedTests).includes(panel)
      ).length;

      const panelCount = Object.keys(this.groupedTests).length - excludedPanels;
      const testCount =
        (this.groupedTests["ALL_TESTS"]?.tests?.length || 0) +
        (this.groupedTests["SEND_OUTS"]?.tests?.length || 0);
      return panelCount + testCount;
    },
    selectedLength() {
      const testsLength = Object.keys(this.selectedTests).length;
      const panelsLength = Object.keys(this.selectedPanels).length;
      return testsLength + panelsLength;
    },
    allItemsSelected() {
      // Check if all rejectable items are selected
      if (this.selectedLength === this.totalRejectableItems) {
        return true;
      } else {
        return false;
      }
    },
  },
  mixins: [FilterHelper, UserPermissionsHelper, AppHelper, caseDataHelper, SearchShortcutMixin, ListRowShortcutsMixin],
  rowShortcutNoun: "case",
  data() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return {
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      disabledDateTat: (time) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // start of today
        return time.getTime() < today.getTime();
      },
      scrollPosition: null,
      showFilters: false,
      // ---- User-customizable filters (order + show/hide), persisted per user ----
      allCasesFilterMeta: [
        { key: "patient_name", label: "Patient Name" },
        { key: "stat", label: "STAT" },
        { key: "date_of_birth", label: "Patient DOB" },
        { key: "ordering_facility", label: "Ordering Facility" },
        { key: "physician", label: "Physician" },
        { key: "case_type", label: "Case Type" },
        { key: "test_id", label: "Test Id" },
        { key: "sales_rep", label: "Sales Rep" },
        { key: "assigned_to", label: "Assigned to" },
        { key: "accession_created_by", label: "Accession Created By" },
        { key: "exception", label: "Exception" },
        { key: "platform", label: "Platform" },
        { key: "priority", label: "Priority" },
        { key: "tat", label: "TAT" },
        { key: "inhouse_sendout", label: "Inhouse/Sendout" },
        { key: "houston_only", label: "Only Houston Cases" },
      ],
      filterOrder: [],
      hiddenFilters: [],
      crossLabCaseStatus: [],
      crossLabStatusOptions: [
        { label: "ACTIVE", value: "ACTIVE" },
        { label: "PROCESSING", value: "TEST_REPORTS" },
        { label: "FINALIZED", value: "COMPLETE" },
        { label: "ARCHIVED", value: "ARCHIVED" },
        { label: "REJECTED", value: "REJECTED" },
      ],
      crossLabFinaliseFrom: "",
      crossLabFinaliseFromOptions: ["Irving", "Houston"],
      groupedTests: {},
      selectedTests: {},
      selectedPanels: {},
      formData: {
        selectedReasons: [],
        notes: "",
        image: null,
      },
      predefinedReasons,
      reasonToActionMap,
      // OptionsRejectPopup state
      showRejectOptionsPopup: false,
      rejectOptionsContext: {
        row: null,
        index: null,
      },
      testIds: {},
      testNames: [],
      usersList: [],
      accessionCreators: [],
      marketerData: [],
      marketingManagerData: [],
      generateBarcodesDialogVisible: false,
      barcode_receive_from_date: "",
      barcode_receive_to_date: "",
      generateQrcodesDialogVisible: false,
      qrcode_receive_from_date: "",
      qrcode_receive_to_date: "",
      page: 1,
      pageSize: 25,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      skipFetchTestPanels: true,
      search_string: "",
      debounceTimer: null,
      fetchSeq: 0,
      searching: false,
      emr: "",
      accession_id: "",
      patient_name: "",
      date_of_birth: "",
      hospital: "",
      selectedHospital: [],
      test_performed_by: [],
      accessionCreatedBy: [],
      hospital_marketer: [],
      physician: [],
      searchBy: "",
      loading: false,
      orderBy: "",
      orderType: "",
      caseType: [],
      test_info: [],
      caseTypes: caseConstants.CASE_TYPES_DATA,
      searchOptions: casesExtraSearchOptions,
      selectedCaseIds: [],
      selectedCaseId: null,
      bulkFaxLoading: false,
      takeReasonDialog: false,
      requestArchiveCase: "",
      takeStatusChangeReasonDialog: false,
      takeStatusMovingReasonDialog: false,
      takeStatusChangeReasonDialogTitle: "",
      unsetCompleteStatusChangeCase: "",
      toStatus: "",
      emrOrderId: "",
      hospitalName: "",
      panelDataCache: {},
      exportReportsDialogVisisble: false,
      hospitalsData: { data: [] },
      physiciansData: {},
      hospitalLoading: false,
      physicianLoading: false,
      userLoading: false,
      pregnant: "",
      errorMessage: false,
      messageData: "",
      testDetailsData: "",
      requestValidationCase: "",
      takeValidationReasonDialog: false,
      havingClinicalChemistry: false,
      showComponent: false,
      casesData: [],
      sendout: "",
      caseSourceFilter: "",
      houstonOnlyCases: "",
      generateTestBarcodesDialogVisible: false,
      tatAcknowledgeDialogVisible:false,
      tatData:{},
      target_tat:tomorrow,
      tatReason:"",
      tatLoading:false,
      test_barcode_receive_from_date: "",
      test_barcode_receive_to_date: "",
      externalLabBarcodesDialogVisible: false,
      externalLabsLoading: false,
      external_lab_barcode_lab_ids: [],
      external_lab_barcode_from_date: "",
      external_lab_barcode_to_date: "",
      exceptionCategoriesMap: exceptionCategories,
      platformCategoriesMap: [],
      billing_sub_status: [],
      testgo_order_type:[],
      showToxColumn: false,
      hasCovidColumns: false,
      showResultColumn: false,
      fromDate: "",
      toDate: "",
      dateType: "created_at",
      dateTypeOptions: [
        { label: "Created On", value: "created_at" },
        { label: "Collection Date", value: "collection_date" },
        { label: "Received Date", value: "received_date" },
      ],
      priority: "",
      tat_colour: [],
      casePriorityTypes: caseConstants.CASE_PROIROTY_TPYES,
      caseTatTypes: caseConstants.CASE_TAT_TPYES,
      showRejectTestPopup: false,
      rejectCaseError: "",
      isStatSort: null,
      showBulkAcknowledgmentDialog : false,
      sampleReceivedLoading: false,
      selectedCases: [],
      bulkSampleReceivedLoading: false,
    };
  },

  async mounted() {
    const versionHandled = localStorage.getItem("versionHandled");
    if (!versionHandled) {
      this.handleVersioning();
      // Set the flag in local storage to indicate that handleVersioning has been called
      localStorage.setItem("versionHandled", "true");
    }
    await this.initData();
    await this.fetchVendors();
    this.loadFilterPreferences();
    // Add Class to body on scroll
    window.addEventListener("Noscroll", this.onScroll);
  },
  watch: {
    getVendorCodes: {
      handler(codes) {
        if (codes && codes.length) {
          this.platformCategoriesMap = codes;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    localStorage.removeItem("searchQueryFacility");
    localStorage.removeItem("searchQueryPhysician");
    localStorage.removeItem("allCases_search_string")
  },
  methods: {
    // ---- User-customizable filters: load / persist order + visibility ----
    loadFilterPreferences() {
      const defaultOrder = this.allCasesFilterMeta.map((f) => f.key);
      let prefs = null;
      const profile = this.getProfileData;
      if (
        profile &&
        profile.filter_preferences &&
        profile.filter_preferences.all_cases
      ) {
        prefs = profile.filter_preferences.all_cases;
      } else {
        try {
          prefs = JSON.parse(localStorage.getItem("allCases_filter_prefs"));
        } catch (e) {
          prefs = null;
        }
      }
      const savedOrder =
        prefs && Array.isArray(prefs.order) ? prefs.order : [];
      const validSaved = savedOrder.filter((k) => defaultOrder.includes(k));
      this.filterOrder = [
        ...validSaved,
        ...defaultOrder.filter((k) => !validSaved.includes(k)),
      ];
      this.hiddenFilters =
        prefs && Array.isArray(prefs.hidden)
          ? prefs.hidden.filter((k) => defaultOrder.includes(k))
          : [];
      // Restore the persistent date-type preference.
      if (prefs && prefs.dateType) {
        this.dateType = prefs.dateType;
      }
    },
    async saveFilterPreferences() {
      const payload = {
        order: this.filterOrder,
        hidden: this.hiddenFilters,
        dateType: this.dateType,
      };
      try {
        localStorage.setItem(
          "allCases_filter_prefs",
          JSON.stringify(payload)
        );
      } catch (e) {}
      try {
        await this.$store.dispatch("profile/updateFilterPreferences", {
          filter_preferences: { all_cases: payload },
        });
      } catch (e) {
        // non-blocking: local copy already saved
      }
    },
    async fetchVendors() {
      await this.$store.dispatch("vendors/fetchVendors", { skip: 0, limit: 100 });
      // Directly update platformCategoriesMap after fetch
      const codes = this.getVendorCodes;
      // console.log("AllCases - After fetchVendors - codes:", codes);
      if (codes && codes.length) {
        this.platformCategoriesMap = codes;
      }
    },
    toggleFilterVisibility(key) {
      if (this.hiddenFilters.includes(key)) {
        this.hiddenFilters = this.hiddenFilters.filter((k) => k !== key);
      } else {
        this.hiddenFilters = [...this.hiddenFilters, key];
      }
      this.saveFilterPreferences();
    },
    resetFilterPreferences() {
      this.filterOrder = this.allCasesFilterMeta.map((f) => f.key);
      this.hiddenFilters = [];
      this.dateType = "created_at";
      this.saveFilterPreferences();
    },
    async acknowledgeCase(){
      try {
        this.tatLoading = true
        let params = {
          tat_ack: true,
          case_id: this.tatData?._id,
          target_tat: this.convertToLabUTC(this.target_tat),
          data_update_reason: this.tatReason,
        }
        await this.$store.dispatch("cases/updateTatAcknowledgement", params)
        if (this.getUpdatedTatAcknodgement) {
          successNotification("Tat acknowledged successfully");
          this.closeTatPopup()
          this.fetchAllCases();
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification("Error while acknowledging the case");
          }
        }
        this.tatLoading = false
      } catch(err){
        this.tatLoading = false
        console.log(err)
      } finally {
        this.tatLoading = false
      }
    },
    closeTatPopup(){
      this.tatData = {}
      this.tatAcknowledgeDialogVisible = false 
      this.tatReason = ""
    },
    acknowledgeTat(data){
      this.tatData = data
      this.tatAcknowledgeDialogVisible = true
    },
    onHospitalChange(value) {
      const selected = Array.isArray(value) ? value : value ? [value] : [];
      this.hospital = selected.length ? selected[0]._id : "";
      this.physician = [];
      this.physiciansData = { data: [] };
      this.handleCurrentChange(1);
    },
    handleStatToggle(value) {
      if (!value) {
        this.fromDate = "";
        this.toDate = "";
        this.page = 1;
      }
      this.handleCurrentChange(1);
    },
    updateIndividualTest(
      testId,
      isChecked,
      panelId,
      caseTypeCode,
      testName,
      testCode,
      labOrderCode,
      testgoOrderCode,
      panelCode
    ) {
      if (isChecked) {
        this.selectedTests = {
          ...this.selectedTests,
          [testId]: {
            panel_id: panelId,
            case_type_code: caseTypeCode,
            test_name: testName,
            test_code: testCode,
            lab_order_code: labOrderCode,
            testgo_order_code: testgoOrderCode,
            panel_code: panelCode, // ✅ added here
          },
        };
      } else {
        const updated = { ...this.selectedTests };
        delete updated[testId];
        this.selectedTests = updated;
      }
      this.checkAllItemsSelected();
    },
    hasMoreThanOneUniqueCategoryCode(testPanelData) {
      if (!testPanelData || !Array.isArray(testPanelData.panels)) return false;

      const panelCodes = testPanelData.panels
        .map((panel) => panel.panel_id?.panel_code)
        .filter(Boolean);
      const uniquePanelCodes = [...new Set(panelCodes)];

      if (uniquePanelCodes.length > 1) {
        return true;
      }

      // Only one panel code present
      if (["ALL_TESTS", "SEND_OUTS"].includes(uniquePanelCodes[0])) {
        // Flatten all test_ids arrays across ALL_TESTS or SEND_OUTS panels
        const allTests = testPanelData.panels
          .filter((panel) =>
            ["ALL_TESTS", "SEND_OUTS"].includes(panel.panel_id?.panel_code)
          )
          .flatMap((panel) => panel.test_ids || []);

        return allTests.length > 1;
      }

      return false;
    },
    selectPanelTests(panelCode, isChecked) {
      const panel = this.groupedTests[panelCode];

      if (panel) {
        if (isChecked) {
          // ✅ Select panel
          this.selectedPanels[panelCode] = true;
        } else {
          // ❌ Remove deselected panel from selectedPanels
          delete this.selectedPanels[panelCode];
          // ❌ Clear all related tests from selectedTests
        }
      } else {
        console.warn(`Panel ${panelCode} not found`);
      }
      this.checkAllItemsSelected();
    },

    async rejectTests(caseId) {
      this.caseId = caseId._id;

      const panelData = this.panelDataCache[caseId._id] ||
        await this.$store.dispatch('cases/fetchCasePanelData', caseId._id);
      if (panelData && !this.panelDataCache[caseId._id]) {
        this.panelDataCache = { ...this.panelDataCache, [caseId._id]: panelData };
      }

      if (panelData?.panels) {
        this.groupedTests = panelData?.panels?.reduce(
          (groups, panel) => {
            const panelCode = panel.panel_id?.panel_code || "Uncategorized";
            const panelTitle = panel.panel_id?.panel_title || panelCode;
            const panelId = panel.panel_id?._id || panelCode;
            const caseTypeCode = panel.case_type_code || "CLINICAL_CHEMISTRY";
            const labOrderCode = panel.lab_order_code || "";
            const testgoOrderCode = panel.testgo_order_code || "";

            if (!groups[panelCode]) {
              groups[panelCode] = {
                title: panelTitle,
                panel_id: panelId,
                case_type_code: caseTypeCode,
                lab_order_code: labOrderCode,
                testgo_order_code: testgoOrderCode,
                tests: [],
              };
            }

            // ✅ Enrich each test with lab_order_code, case_type_code, panel_code
            const enrichedTests = panel.test_ids.map((test) => ({
              ...test,
              lab_order_code: labOrderCode,
              testgo_order_code: testgoOrderCode,
              case_type_code: caseTypeCode,
              panel_code: panelCode,
            }));

            groups[panelCode].tests = [
              ...groups[panelCode].tests,
              ...enrichedTests,
            ];

            return groups;
          },
          {}
        );
      } else {
        this.groupedTests = {};
      }

      this.showRejectTestPopup = true;
    },
    updateNotes(val) {
      if (val !== undefined) {
        this.formData.notes = val;
      } else {
        const actions = this.formData.selectedReasons
          .map((reason) => this.reasonToActionMap[reason])
          .filter((action) => action);
        this.formData.notes = actions.join("\n");
      }
    },
    updateRejectImage(val) {
      this.formData.image = val;
    },
    closeIconRejectPopup() {
      this.rejectCaseError = "";
      this.showRejectTestPopup = false;
      this.groupedTests = {};

      this.selectedPanels = {};
      this.selectedTests = {};

      // Clear formData
      this.formData.selectedReasons = [];
      this.formData.notes = "";
      this.formData.image = null;

      this.$nextTick(() => {
        this.$refs.ruleForm?.resetFields();
      });
    },

    async rejectSelectedTests() {
      this.rejectCaseError = "";
      this.loading = true;
      try {
        const panels = [];
        const selectedPanelCodes = Object.keys(this.selectedPanels).filter(
          (code) => this.selectedPanels[code]
        );
        const includedPanelIds = new Set();
        // ✅ Step 1: Add full panels
        for (const panelCode of selectedPanelCodes) {
          const panelData = this.groupedTests[panelCode];
          if (!panelData) continue;

          panels.push({
            panel_id: panelData.panel_id,
            case_type_code: panelData.case_type_code || "CLINICAL_CHEMISTRY",
            all_tests: true,
            test_ids: panelData.tests.map((test) => test._id),
            lab_order_code: panelData.lab_order_code || "",
            testgo_order_code: panelData.testgo_order_code || "",
          });

          includedPanelIds.add(panelData.panel_id);
        }

        // ✅ Step 2: Handle individually selected tests
        const groupedByPanel = {};

        for (const [testId, testInfo] of Object.entries(this.selectedTests)) {
          if (includedPanelIds.has(testInfo.panel_id)) continue; // Skip already handled

          if (
            testInfo.panel_code === "ALL_TESTS" ||
            testInfo.panel_code === "SEND_OUTS"
          ) {
            // ✅ Split ALL_TESTS entries into separate panel objects
            panels.push({
              panel_id: testInfo.panel_id,
              case_type_code: testInfo.case_type_code || "CLINICAL_CHEMISTRY",
              all_tests: true,
              test_ids: [testId],
              lab_order_code: testInfo.lab_order_code || "",
              testgo_order_code: testInfo.testgo_order_code || "",
            });
          } else {
            // Group by panel_id normally
            if (!groupedByPanel[testInfo.panel_id]) {
              groupedByPanel[testInfo.panel_id] = {
                panel_id: testInfo.panel_id,
                case_type_code: testInfo.case_type_code || "CLINICAL_CHEMISTRY",
                all_tests: true,
                test_ids: [],
                lab_order_code: testInfo.lab_order_code || "",
                testgo_order_code: testInfo.testgo_order_code || "",
              };
            }
            groupedByPanel[testInfo.panel_id].test_ids.push(testId);
          }
        }

        // ✅ Merge grouped panels (non-"ALL_TESTS") into final panels array
        panels.push(...Object.values(groupedByPanel));

        // ✅ Create tests_info
        const tests_info = panels.flatMap((panel) => panel.test_ids);

        // ✅ Final payload
        const params = {
          case_id: this.caseId,
          panels,
          tests_info,
          notes: this.formData.notes,
          reasons: this.formData.selectedReasons,
          image: this.formData.image,
        };
        await this.$store.dispatch("rejectTestInfo/createCCRCase", params);
        if (panels.length > 0) {
          successNotification("Test rejected successfully");
        }
        window.location.reload();
        this.closeIconRejectPopup();
      } catch (error) {
        console.error("Error rejecting tests:", error);
        this.rejectCaseError = "Error Rejecting Tests";
      } finally {
        this.loading = false;
      }
    },
    async loadPanelDataForRow(row) {
      if (this.panelDataCache[row._id] !== undefined) return;
      if (!row.case_types?.includes('CLINICAL_CHEMISTRY')) return;
      const data = await this.$store.dispatch('cases/fetchCasePanelData', row._id);
      this.panelDataCache = { ...this.panelDataCache, [row._id]: data };
    },
    openRejectOptions(row, index) {
      this.rejectOptionsContext = { row, index };
      this.showRejectOptionsPopup = true;
    },
    onPartialRejectOption() {
      const selected = this.rejectOptionsContext;
      if (!selected || !selected.row) return;
      // Open existing TestsRejectPopup flow with the selected row
      this.showRejectOptionsPopup = false;
      this.rejectTests(selected.row);
    },
    async onCompleteRejectOption() {
      const selected = this.rejectOptionsContext;
      if (!selected || !selected.row) return;
      this.showRejectOptionsPopup = false;
      // Call existing changeStatus to REJECTED, preserving current behavior
      try {
        await this.changeStatus("REJECTED", selected.row, selected.index);
      } catch (e) {
        console.error(e);
      }
    },

    checkAllItemsSelected() {
      if (this.allItemsSelected) {
      }
    },
    viewPhlebioOrder(phleboId) {
      this.$router.push({
        name: "PhlebioOrderDetails",
        params: {
          phlebio_id: phleboId,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async remoteMethodFacility(query) {
      if (query !== "") {
        localStorage.setItem("searchQueryFacility", query);
        await this.fetchAllHospitals(query);
      } else {
        await this.fetchAllHospitals();
      }
    },
    async remoteMethodAccessionCreator(query) {
      await this.fetchAccessionCreators(query);
    },
    onAccessionCreatorChange(selectedIds) {
      this.accessionCreatedBy = Array.isArray(selectedIds)
        ? selectedIds.filter(Boolean)
        : selectedIds
          ? [selectedIds]
          : [];
      this.handleCurrentChange(1);
    },
    onHospitalFocus() {
      if (!this.hospitalsData.data || !this.hospitalsData.data.length) {
        this.fetchAllHospitals();
      }
    },
    async generatePathologyReport(report) {
      const formattedDate = moment(report.finalized_date).format(
        "MM/DD/YYYY hh:mm A"
      );

      let testResultsId;

      const testReportsData = report.test_reports;
      for (let i = 0; i < testReportsData.length; i++) {
        if (testReportsData[i].mark_for_physician) {
          testResultsId = testReportsData[i].test_results_id;
        }
      }

      this.loading = true;
      try {
        let params = {
          case_id: report._id,
          test_results_id: testResultsId,
          pathologist_date: formattedDate,
        };
        await this.$store.dispatch("cases/pathologyReport", params);
        if (this.getGeneratePathologyReportStatus) {
          successNotification("Pathology report generated successfully!");
        } else {
          errorNotification(
            this.getError || "Error while generating pathology report"
          );
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async onDownloadPathologyReport(pathologyPath) {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/fetchTestReportDownloadURL", {
          path: "test_reports/" + pathologyPath.pathology_report_path,
        });
        if (
          this.getDownloadReportData &&
          this.getDownloadReportData.data &&
          this.getDownloadReportData.data.download_url
        ) {
          let url = this.getDownloadReportData.data.download_url;
          const fileStream = await axios({
            url: url,
            method: "GET",
            responseType: "blob",
          });
          const urlObject = window.URL || window.webkitURL;
          const downloadUrl = urlObject.createObjectURL(fileStream.data);
          let accessionId = pathologyPath.accession_id;
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", `${accessionId} pathology_report.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          successNotification("Pathology report downloaded successfully");
        } else if (!this.getDownloadReportData) {
          errorNotification(
            this.getError || "Error while downloading pathology report"
          );
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    updateColumnVisibility() {
      const data = this.getAllCases && this.getAllCases.data;
      if (!data || !data.length) {
        this.showToxColumn = false;
        this.hasCovidColumns = false;
        this.showResultColumn = false;
        return;
      }
      let allTox = true, allCovid = true, allResult = true;
      for (const item of data) {
        const types = item.case_types;
        if (allTox && !types.every((t) => t === "TOXICOLOGY")) allTox = false;
        if (allCovid && !types.includes("COVID") && !types.includes("COVID_FLU")) allCovid = false;
        if (allResult && !caseConstants.UTI_RPP_CASE_TYPES.some((t) => types.includes(t))) allResult = false;
        if (!allTox && !allCovid && !allResult) break;
      }
      this.showToxColumn = allTox;
      this.hasCovidColumns = allCovid;
      this.showResultColumn = allResult;
    },
    updateShowToxColumn() { this.updateColumnVisibility(); },
    updateCovidColumn() { this.updateColumnVisibility(); },
    updateResultColumn() { this.updateColumnVisibility(); },
    getRerunNotes(row) {
      if (!Array.isArray(row.report_notes)) return [];
      return row.report_notes.filter(
        (note) => (note.title || "").trim().toLowerCase() === "rerun"
      );
    },
    getLatestRerunNote(row) {
      const notes = this.getRerunNotes(row);
      if (!notes.length) return null;
      return notes.reduce((latest, note) =>
        new Date(note.added_at || 0) > new Date(latest.added_at || 0)
          ? note
          : latest
      );
    },
    isRerunCase(row) {
      return this.getRerunNotes(row).length > 0;
    },
    tableRowClassName({ row }) {
      const resultClass = this.resultRowClassName(row);
      const onInsuranceHold =
        row.insurance_hold && row.insurance_hold.state === "ON_HOLD";
      // Rerun and critical/abnormal rows keep their own colour; the pill under
      // the accession id still marks the hold on those.
      if (onInsuranceHold && ["", "finalized-case"].includes(resultClass)) {
        return `${resultClass} insurance-hold-row`.trim();
      }
      return resultClass;
    },
    resultRowClassName(row) {
      if (this.isRerunCase(row)) {
        return "highlight-rerun";
      }
      if (this.getAuthenticatedUser) {
        const userRole = this.getAuthenticatedUser.user_type;
        const allowedRoles = [
          "LAB_ADMIN",
          "LAB_MANAGER",
          "LAB_DATA_ASSISTANT",
          "LAB_SUPER_ADMIN",
          "LAB_TECHNOLOGIST",
          "LAB_DATA_ADMIN",
        ];
        if (allowedRoles.includes(userRole)) {
          if (
            this.checkNewReport(row) &&
            (row.is_critical || row.is_abnormal)
          ) {
            return "highlight-generated";
          } else if (row.is_critical || row.is_abnormal) {
            return "highlight-viewed"; // If both are true, use this class
          } else if (this.checkNewReport(row)) {
            return "finalized-case";
          }
        }
      }
      return "";
    },
    gotoPatientResultsTrendClinicalChemistry(patient) {
      if (patient && patient.internal_patient_id) {
        const patientResultsUrl = process.env.VUE_APP_PATIENT_TREND_RESULTS;
        const patientID = patient.internal_patient_id;
        let url;
        if (this.isOrderingPhysician) {
          let physicianId = this.getAuthenticatedUser._id;
          url = `${patientResultsUrl}/patient-results/blood-results/${patientID}?physician_id=${physicianId}`;
        } else {
          url = `${patientResultsUrl}/patient-results/blood-results/${patientID}`;
        }
        window.open(url, "_blank");
      }
    },
    gotoPatientResultsTrendToxiclogy(patient) {
      if (patient && patient.internal_patient_id) {
        const patientResultsUrl = process.env.VUE_APP_PATIENT_TREND_RESULTS;
        const patientID = patient.internal_patient_id;
        let url;
        if (this.isOrderingPhysician) {
          let physicianId = this.getAuthenticatedUser._id;
          url = `${patientResultsUrl}/patient-results/toxicology-results/${patientID}?physician_id=${physicianId}`;
        } else {
          url = `${patientResultsUrl}/patient-results/toxicology-results/${patientID}`;
        }
        window.open(url, "_blank");
      }
    },
    handleVersioning() {
      const currentVersion = config.APP_VERSION;
      const currentAppName = config.APP_NAME;
      const versionKey = "APP_VERSION";
      const appName = "APP_NAME";
      if (localStorage.getItem(versionKey) !== currentVersion) {
        localStorage.clear();
        localStorage.setItem(versionKey, currentVersion);
        localStorage.setItem(appName, currentAppName);
        window.location.reload(true);
      }
    },
    initializeSearchOptions() {
      this.searchOptions = [...this.searchOptions];
      this.filterSearchOptions();
    },
    filterSearchOptions() {
      if (this.isChantillyLab) {
        const optionsToRemove = ["Tat"];
        this.searchOptions = this.searchOptions.filter(
          (option) => !optionsToRemove.includes(option.value)
        );
      }
      if (this.isLabTechnologistUser || this.isLabAssistantUser) {
        const optionsToRemove = ["hospital_marketers", "billing_sub_status",];
        this.searchOptions = this.searchOptions.filter(
          (option) => !optionsToRemove.includes(option.value)
        );
      }
    },
    viewEMR(orderId) {
      this.$router.push({
        name: "View-Case-Information",
        params: { order_id: orderId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async remoteMethodPhysician(query) {
      if (query !== "") {
        localStorage.setItem("searchQueryPhysician", query);
        await this.fetchAllPhysicians(query);
      } else {
        await this.fetchAllPhysicians();
      }
    },
    onPhysicianFocus() {
      if (!this.physiciansData.data || !this.physiciansData.data.length) {
        this.fetchAllPhysicians();
      }
    },
    async moveToValidations(validation) {
      this.requestValidationCase = validation;
      this.takeValidationReasonDialog = true;
    },
    sendParameter(row) {
      let isOldOrder = false;
      if (row.order_id) {
        isOldOrder = true;
        this.goToOrderView(row.order, isOldOrder);
      } else if (row.testgo_order_id) {
        this.goToOrderView(row.order,isOldOrder);
      }
    },
    goToOrderView(order_id, isOldOrder = false) {
      this.$router.push({
        name: "Order-Information",
        params: { order_id: order_id },
        query: {
          ...this.$route.query,
          redirectRoute: this.$route.name,
          isOldOrder: isOldOrder,
        },
      });
    },
    async moveToValidation(reason) {
      try {
        this.loading = true;
        let params = {
          id: this.requestValidationCase,
          status: true,
          validation_reason: reason,
        };
        await this.$store.dispatch("cases/changeCaseValidationStatus", params);
        if (this.getUpdateValidationStatus) {
          successNotification("Case moved to validation Cases");
          await this.fetchAllCases();
        } else {
          errorNotification("Error while moving case to validation cases");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    timeDifference(time) {
      if (time && time.created_at) {
        let createdTime = time.created_at.split("T")[1].split(".")[0];
        let currentTime = new Date();
        let utcTime = currentTime.toISOString();
        let actualUtcTime = utcTime.split("T")[1].split(".")[0];
        let time1 = new Date(`1970-01-01T${createdTime}`);
        let time2 = new Date(`1970-01-01T${actualUtcTime}`);
        let diff = new Date(time2 - time1);
        let UTC = diff.toISOString();
        let UTCtime = UTC.split("T")[1].split(".")[0];
        let minutes = UTCtime.split(":");
        let minutesSeconds = minutes[1] + ":" + minutes[2];
        return minutesSeconds;
      }
    },
    async onScroll() {
      // Get the scroll position, you can adjust this value based on your requirement
      const scrollPosition = window.scrollY;
      // Add a class to the body element based on the scroll position
      if (scrollPosition > 1) {
        document.body.classList.add("fixedNavbarOnComponent");
      } else {
        document.body.classList.remove("fixedNavbarOnComponent");
      }
    },
    async sentToLabdaq(caseId) {
      this.loading = true;
      try {
        let params = {
          case_id: caseId,
        };
        await this.$store.dispatch("cases/sendAccessionToLabdaq", params);
        if (this.getSendAccessionToLabdaq) {
          successNotification("Order sent to LABDAQ successfully");
          this.fetchAllCases();
        } else if (
          this.getSendToLabdaqValiationError &&
          this.getSendToLabdaqValiationError.error_code &&
          (this.getSendToLabdaqValiationError.error_code ===
            "ORDER_CODE_NOT_FOUND" ||
            this.getSendToLabdaqValiationError.error_code ===
              "TESTS_NOT_MATCHED" ||
            this.getSendToLabdaqValiationError.error_code ===
              "LABDAQ_ORDERING_FACILITY_NOT_FOUND")
        ) {
          this.messageData = this.getSendToLabdaqValiationError.message;

          this.testDetailsData = (this.getSendToLabdaqValiationError.errors || [])
            .map((e) => e)
            .join(", ");
          this.errorMessage = true;
        } else {
          errorNotification("Error while sending order to LABDAQ");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async syncLabdaqReports(caseId) {
      try {
        this.loading = true;
        let params = {
          case_id: caseId,
        };
        await this.$store.dispatch("cases/synsAccessionToLabdaq", params);
        if (this.getSyncAccessionToLabdaq) {
          successNotification("Reports sync successfully");
          await this.fetchAllCases();
        } else {
          errorNotification("Report not synced.");
          await this.fetchAllCases();
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async testReportsDownloadLog(report, testReports) {
      let params = {
        case_id: report._id,
        report_id: testReports._id,
      };
      await this.$store.dispatch("cases/testReportsDownloadLog", params);
    },
    async testReportsViewLog(report, testReports) {
      let params = {
        case_id: report._id,
        report_id: testReports._id,
      };
      await this.$store.dispatch("cases/testReportsViewLog", params);
    },
    checkSendOutDisable(report) {
      let caseType = report.is_sendout;
      if (caseType == true) {
        return true;
      } else {
        return false;
      }
    },
    async onReportsExport() {
      this.loading = true;

      this.exportReportsDialogVisisble = true;
      this.loading = false;
    },
    async changeStatus(command, caseData, index) {
      if (command === "NOT_TO_CALL") {
        return;
      }
      try {
        if (command == caseData.status) {
          return;
        }
        this.takeStatusChangeReasonDialogTitle = command;

        let params = {
          status: command,
          id: caseData._id,
        };

        this.emrOrderId = caseData?.emr_order;
        this.hospitalName = caseData?.hospital?.name;

        if (caseData.status == "COMPLETE" || command == "COMPLETE") {
          this.unsetCompleteStatusChangeCase = caseData._id;
          this.toStatus = command;
          this.caseIndex = index;
          this.askReasonOnUnsetCompletedStatus();
        } else if (
          (caseData.status == "ACTIVE" || caseData.status == "TEST_REPORTS") &&
          command == "REJECTED"
        ) {
          this.unsetCompleteStatusChangeCase = caseData._id;
          this.toStatus = command;
          this.caseIndex = index;

          this.askReasonOnUnsetStatus();
        } else {
          await this.updateStatus(params, index);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async unsetCaseMovingStatus(data) {
      let params = {
        id: this.unsetCompleteStatusChangeCase,
        status: this.toStatus,
        notes: data.notes,
      };
      if (data.reasons && data.reasons.length > 0) {
        params.reasons = data.reasons;
      }
      if (data.image) {
        params.image = data.image;
      }
      await this.updateStatus(params, this.caseIndex);
      if (
        this.toStatus == "REJECTED" &&
        this.hospitalName.trim() == "ADVANCED INTERNAL MEDICINE"
      ) {
        let params = {
          case_id: this.unsetCompleteStatusChangeCase,
          emr_order_id: this.emrOrderId,
          message: data.notes,
        };
        await this.sendRejection(params);
      }
    },
    async unsetCaseCompleteStatus(reason) {
      let params = {
        id: this.unsetCompleteStatusChangeCase,
        status: this.toStatus,
        reason,
      };

      await this.updateStatus(params, this.caseIndex);
    },
    async askReasonOnUnsetStatus() {
      this.takeStatusMovingReasonDialog = true;
    },
    async askReasonOnUnsetCompletedStatus() {
      this.takeStatusChangeReasonDialog = true;
      this.takeStatusChangeReasonDialogTitle =
        "Reason for moving from Complete to " +
        this.toStatus
          .split("_")
          .map((e) => this.capitalize(e))
          .join(" ");
    },
    async updateStatus(params, index) {
      try {
        this.loading = true;

        // Prepare params for store action
        let storeParams;
        if (params.image) {
          // If there's an image, create FormData
          const formData = new FormData();
          formData.append('status', params.status);
          if (params.notes) {
            formData.append('notes', params.notes);
          }
          if (params.reasons && params.reasons.length > 0) {
            formData.append('reasons', JSON.stringify(params.reasons));
          }
          formData.append('image', params.image);

          // Pass both ID and FormData separately to store
          storeParams = {
            id: params.id,
            formData: formData
          };
        } else {
          // Regular params object
          storeParams = params;
        }

        await this.$store.dispatch("cases/changeCaseStatus", storeParams, {
          root: true,
        });
        this.loading = false;
        if (this.getUpdateCaseStatus && this.getUpdateCaseStatus.success) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getUpdateCaseStatus.message,
          });
          this.fetchAllCases();
          this.getAllCases.data[index].status = params.status;
          this.selectedCaseForBilling = null;
          this.patientSSN = "";
          this.patientRelationship = "";
          this.showBillingDetailsForm = false;
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    async sendRejection(params) {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "cases/practiceFusionRejectionMessage",
          params
        );
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    clearSearchBy() {
      if (this.$route.query.selectedSearchBy == "Sendout") {
        this.fetchAllCases(1);
      }
      if (this.$route.query.selectedSearchBy == "inhouse") {
        this.fetchAllCases(1);
      }
    },
    clearAllFilters() {
      this.search_string = "";
      this.patient_name = "";
      this.isStatSort = null;
      this.selectedHospital = [];
      this.hospital = "";
      this.physician = [];
      this.date_of_birth = "";
      this.caseType = [];
      this.test_info = [];
      this.hospital_marketer = [];
      this.test_performed_by = [];
      this.accessionCreatedBy = [];
      this.billing_sub_status = [];
      this.testgo_order_type = [];
      this.priority = "";
      this.tat_colour = [];
      this.caseSourceFilter = "";
      this.houstonOnlyCases = "";
      this.crossLabCaseStatus = [];
      this.crossLabFinaliseFrom = "";
      this.accession_id = "";
      this.emr = "";
      this.fromDate = "";
      this.toDate = "";
      this.page = 1;
      try {
        localStorage.removeItem("allCases_search_string");
      } catch (e) {}
      this.fetchAllCases(1);
    },
    clearInputSearch() {
      if (
        this.hospital ||
        this.physician ||
        this.date_of_birth ||
        this.caseType.length ||
        this.test_info.length ||
        this.emr ||
        this.patient_name ||
        this.accession_id ||
        this.test_performed_by ||
        this.hospital_marketer.length ||
        this.patient_name ||
        this.billing_sub_status ||
        this.priority ||
        this.tat_colour ||
        this.fromDate ||
        this.toDate ||
        this.testgo_order_type ||
        this.caseSourceFilter
      ) {
        this.hospital = "";
        this.selectedHospital = [];
        this.test_performed_by = [];
        this.hospital_marketer = [];
        this.physician = [];
        this.date_of_birth = "";
        this.caseType = [];
        this.test_info = [];
        this.emr = "";
        this.patient_name = "";
        this.testgo_order_type = []
        this.accession_id = "";
        this.patient_name = "";
        this.billing_sub_status = [];
        (this.priority = ""),
          (this.fromDate = ""),
          (this.toDate = ""),
          (this.page = 1);
        (this.tat_colour = []),
          (this.fromDate = ""),
          (this.toDate = ""),
          (this.page = 1);

        this.fetchAllCases(1);
      }
      if (this.searchBy == "Sendout") {
        this.fetchAllCases(1);
      }
      if (this.searchBy == "inhouse") {
        this.fetchAllCases(1);
      }
    },
    onSelectedDatesGenerateBarcodes() {
      if (
        this.barcode_receive_from_date != "" &&
        this.barcode_receive_to_date != ""
      ) {
        let urlData = this.$router.resolve({
          name: "MultipleBarcodes",
          path: "multiple-barcodes",
          query: {
            from_date: this.barcode_receive_from_date,
            to_date: this.barcode_receive_to_date,
          },
        });
        this.barcode_receive_from_date = "";
        this.barcode_receive_to_date = "";
        this.generateBarcodesDialogVisible = false;
        window.open(urlData.href, "_blank");
      }
    },
    onSelectedDatesGenerateQrcodes() {
      if (
        this.qrcode_receive_from_date != "" &&
        this.qrcode_receive_to_date != ""
      ) {
        let urlData = this.$router.resolve({
          name: "MultipleQrcodes",
          path: "multiple-qrcodes",
          query: {
            from_date: this.qrcode_receive_from_date,
            to_date: this.qrcode_receive_to_date,
          },
        });
        this.qrcode_receive_from_date = "";
        this.qrcode_receive_to_date = "";
        this.generateQrcodesDialogVisible = false;
        window.open(urlData.href, "_blank");
      }
    },
    onSelectedDatesGenerateTestBarcodes() {
      if (
        this.test_barcode_receive_from_date != "" &&
        this.test_barcode_receive_to_date != ""
      ) {
        let urlData = this.$router.resolve({
          name: "MultipleTestBarcodes",
          path: "multiple-test-barcodes",
          query: {
            from_date: this.test_barcode_receive_from_date,
            to_date: this.test_barcode_receive_to_date,
          },
        });
        this.test_barcode_receive_from_date = "";
        this.test_barcode_receive_to_date = "";
        this.generateTestBarcodesDialogVisible = false;
        window.open(urlData.href, "_blank");
      }
    },
    async changeCovidStatus(command, id, index, prevStatus) {
      try {
        this.loading = true;
        if (command == prevStatus) {
          return;
        }
        let params = {
          status: command,
          id: id,
        };
        await this.$store.dispatch("cases/changeCaseCovidStatus", params, {
          root: true,
        });
        if (
          this.getUpdateCaseCovidStatus &&
          this.getUpdateCaseCovidStatus.success
        ) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getUpdateCaseCovidStatus.message,
          });
          this.getAllCases.data[index].covid_status = command;
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    hadMaxLength(caseData) {
      return (
        caseData.case_types.indexOf("CLINICAL_CHEMISTRY") > -1 ||
        caseData.case_types.indexOf("COVID_FLU") > -1 ||
        caseData.case_types.indexOf("PAD_ALZHEIMERS") > -1
      );
    },
    hasCovid(caseData) {
      return (
        caseData.case_types.indexOf("COVID") > -1 ||
        caseData.case_types.indexOf("COVID_FLU") > -1
      );
    },
    hasBloodCaseType(caseData) {
      return caseData.case_types.indexOf("CLINICAL_CHEMISTRY") > -1;
    },
    async initData() {
      await this.setQueryParamsData();
      await Promise.all([this.fetchAllCases()]);
    },
    async setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      } else {
        // Restore persisted search term when route doesn't include it
        try {
          const persisted = localStorage.getItem("allCases_search_string");
          if (persisted) {
            this.search_string = persisted;
          }
        } catch (e) {
          // ignore
        }
      }
      if (this.$route.query.selectedPatientName) {
        this.patient_name = this.$route.query.selectedPatientName;
      }
      if (this.$route.query.selectedEMR) {
        this.emr = this.$route.query.selectedEMR;
      }
      if (this.$route.query.is_stat) {
        this.priority = this.$route.query.is_stat;
      }
      if (this.$route.query.tat_colour) {
        const selTat = this.$route.query.tat_colour;
        this.tat_colour = Array.isArray(selTat) ? selTat : [selTat];
      }
      if (this.$route.query.fromDate) {
        this.fromDate = this.$route.query.fromDate;
      }
      if (this.$route.query.toDate) {
        this.toDate = this.$route.query.toDate;
      }
      if (this.$route.query.selectedAccessionId) {
        this.accession_id = this.$route.query.selectedAccessionId;
      }
      if (this.$route.query.selectedCase) {
        const selectedCase = this.$route.query.selectedCase;
        this.caseType = Array.isArray(selectedCase) ? selectedCase : [selectedCase];
        await this.fetchAllTestPanels();
      }
      if (this.$route.query.selectedTest && this.$route.query.selectedTest.length) {
        if (!Array.isArray(this.testIds) || !this.testIds.length) {
          await this.fetchAllTestPanels();
        }
        const selectedCategories = Array.isArray(this.$route.query.selectedTest)
          ? this.$route.query.selectedTest
          : [this.$route.query.selectedTest];
        this.test_info = this.testIds
          .filter((t) => selectedCategories.includes(t.category))
          .map((t) => t.tests);
      }
      if (this.$route.query.selectedCaseId) {
        this.selectedCaseId = this.$route.query.selectedCaseId;
      }
      if (this.$route.query.selectedCaseOrderBy) {
        this.orderBy = this.$route.query.selectedCaseOrderBy;
      }
      if (this.$route.query.selectedCaseOrderType) {
        this.orderType = this.$route.query.selectedCaseOrderType;
      }
      if (this.$route.query.selectedPhysician) {
        const savedQuery = localStorage.getItem("searchQueryPhysician");
        if (savedQuery && this.$route.query.selectedString !== savedQuery) {
          this.fetchAllPhysicians(savedQuery);
        }
        const rawPhys = this.$route.query.selectedPhysician;
        const physicianIds = Array.isArray(rawPhys) ? rawPhys : [rawPhys];
        this.physician = physicianIds;
        // Inject placeholders so the select renders labels before data loads
        const rawPhysNames = this.$route.query.selectedPhysicianName;
        const physicianNames = Array.isArray(rawPhysNames)
          ? rawPhysNames
          : [rawPhysNames];
        if (!this.physiciansData || !Array.isArray(this.physiciansData.data)) {
          this.physiciansData = { data: [] };
        }
        physicianIds.forEach((id, i) => {
          if (!this.physiciansData.data.some((p) => p._id === id)) {
            this.physiciansData.data = [
              { _id: id, name: physicianNames[i] || "" },
              ...this.physiciansData.data,
            ];
          }
        });
      }
      if (this.$route.query.selectedHospital) {
        const savedQuery = localStorage.getItem("searchQueryFacility");
        if (savedQuery && this.$route.query.selectedString !== savedQuery) {
          this.fetchAllHospitals(savedQuery);
        }
        const rawIds = this.$route.query.selectedHospital;
        const hospitalIds = Array.isArray(rawIds) ? rawIds : [rawIds];
        const rawNames = this.$route.query.selectedHospitalName;
        const hospitalNames = Array.isArray(rawNames) ? rawNames : [rawNames];
        this.hospital = hospitalIds[0] || "";
        const existing =
          this.hospitalsData && Array.isArray(this.hospitalsData.data)
            ? this.hospitalsData.data
            : [];
        this.selectedHospital = hospitalIds.map((id, i) => {
          const found = existing.find((h) => h._id === id);
          return found || { _id: id, name: hospitalNames[i] || "" };
        });
        const missing = this.selectedHospital.filter(
          (h) => !existing.some((e) => e._id === h._id)
        );
        if (missing.length) {
          this.hospitalsData.data = [...existing, ...missing];
        }
      }
      if (this.$route.query.selectedUser) {
        this.fetchAllUsers();
        const selUser = this.$route.query.selectedUser;
        this.test_performed_by = Array.isArray(selUser) ? selUser : [selUser];
      }
      if (this.$route.query.selectedAccessionCreatedBy) {
        this.fetchAllUsers();
        const selCreator = this.$route.query.selectedAccessionCreatedBy;
        this.accessionCreatedBy = Array.isArray(selCreator)
          ? selCreator
          : [selCreator];
      }
      if (this.$route.query.selectedMarketer) {
        this.fetchAllUsers();
        this.hospital_marketer = Array.isArray(this.$route.query.selectedMarketer)
          ? this.$route.query.selectedMarketer
          : [this.$route.query.selectedMarketer];
      }
      if (this.$route.query.selectedDateOfBirth) {
        this.date_of_birth = this.$route.query.selectedDateOfBirth;
      }
      this.searchBy = this.$route.query.selectedSearchBy;
      if (this.$route.query.selectedException) {
        const selExc = this.$route.query.selectedException;
        this.billing_sub_status = Array.isArray(selExc) ? selExc : [selExc];
      }
      if(this.$route.query.selectedPlatform){
        const selPlat = this.$route.query.selectedPlatform;
        this.testgo_order_type = Array.isArray(selPlat) ? selPlat : [selPlat];
      }
      if(this.$route.query.selectedCaseSource){
        this.caseSourceFilter = this.$route.query.selectedCaseSource
      }
      if (this.$route.query.selectedHoustonOnly) {
        this.houstonOnlyCases = this.$route.query.selectedHoustonOnly;
      }
      if (this.crossLabRegistered && this.$route.query.selectedCaseStatus) {
        const selStatus = this.$route.query.selectedCaseStatus;
        this.crossLabCaseStatus = Array.isArray(selStatus)
          ? selStatus
          : [selStatus];
      }
      if (this.crossLabRegistered && this.$route.query.selectedFinaliseFrom) {
        this.crossLabFinaliseFrom = this.$route.query.selectedFinaliseFrom;
      }
    },
    async fetchAllPhysicians(physician) {
      this.physicianLoading = true;
      let params = {
        get_all: true,
      };
      if (physician && typeof physician === 'string') {
        params.search_string = physician;
      }
      if (Array.isArray(this.selectedHospital) && this.selectedHospital.length === 1) {
        params.hospital = this.selectedHospital[0]._id;
      }
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
      this.physicianLoading = false;
    },
    async fetchAllHospitals(hospital) {
      this.hospitalLoading = true;
      let params = {
        get_all: true,
        status: "ACTIVE",
      };
      if (hospital && typeof hospital === 'string') {
        params.search_string = hospital;
      }
      await this.$store.dispatch("hospitals/fetchAllHospitals", params);
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      this.hospitalLoading = false;
    },
    async fetchAllUsers() {
      this.userLoading = true;

      await this.$store.dispatch("userAccounts/fetchAllUserAccounts", {
        get_all: true,
        order_by: "first_name",
        order_type: "asc",
        status: "ACTIVE",
      });
      if (this.getAllUsers && this.getAllUsers.data) {
        let usersForTestPerofmed = ["LAB_TECHNOLOGIST"];
        this.usersList = this.getAllUsers.data.filter((item) =>
          usersForTestPerofmed.includes(item.user_type)
        );
        this.accessionCreators = this.getAllUsers.data;
        let marketer = ["MARKETER","HOSPITAL_MARKETING_MANAGER","SALES_DIRECTOR","REGIONAL_DIRECTOR","SALES_SUPPORT_TEAM"];
        this.marketerData = this.getAllUsers.data.filter((item) =>
          marketer.includes(item.user_type)
        );
      }
      this.userLoading = false;
    },
    async fetchAccessionCreators(searchString = "") {
      this.userLoading = true;
      try {
        const normalizedSearchString = typeof searchString === "string"
          ? searchString.trim()
          : "";
        const params = normalizedSearchString
          ? { search_string: normalizedSearchString }
          : {};
        const response = await this.$store.dispatch(
          "cases/fetchAccessionCreators",
          params
        );
        this.accessionCreators = response?.data || [];
      } finally {
        this.userLoading = false;
      }
    },
    prepareParams() {
      this.pregnant = "";
      this.sendout = "";
      
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.validationStatus) {
        params.is_validation_purpose = true;
      }
      if (this.issues === true) {
        params.issues = true;
      }
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.emr) {
        params.emr = this.emr;
      }
      if (this.accession_id) {
        params.accession_id = this.accession_id;
      }
      if (this.patient_name) {
        params.patient_name = this.patient_name;
      }
      if (this.date_of_birth) {
        const date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");

        params.date_of_birth = date_of_birth;
      }
      if (this.fromDate) {
        params.from_date = this.fromDate;
      }
      if (this.toDate) {
        params.to_date = this.toDate;
      }
      if ((this.fromDate || this.toDate) && this.dateType) {
        params.date_type = this.dateType;
      }
      if (this.priority == "Stat") {
        params.is_stat = true;
      }
      if (this.priority == "Routine") {
        params.is_stat = false;
      }
      if (this.tat_colour && this.tat_colour.length) {
        params.tat_colour = this.tat_colour;
      }
      if (Array.isArray(this.selectedHospital) && this.selectedHospital.length) {
        params.hospitals = this.selectedHospital
          .map((h) => h && h._id)
          .filter(Boolean);
      }
      if (this.test_performed_by && this.test_performed_by.length) {
        params.test_performed_by = this.test_performed_by;
      }
      if (this.accessionCreatedBy && this.accessionCreatedBy.length) {
        params.accession_created_by = this.accessionCreatedBy;
      }
      if (this.hospital_marketer.length) {
        params.hospital_marketers = this.hospital_marketer;
      }
      if (this.caseType && this.caseType.length) {
        params.case_type = this.caseType;
      }
      if (this.test_info.length) {
        params.tests_info = [].concat.apply([], this.test_info);
      }
      if (this.physician && this.physician.length) {
        params.ordering_physician = this.physician;
      }
      if (this.searchBy == "Pregnancy") {
        this.pregnant = true;
        params.pregnant = true;
      }
      if (this.searchBy == "Sendout") {
        this.sendout = true;
        params.is_sendout = true;
      }
      if (this.searchBy == "inhouse") {
        this.inhouse = true;
        params.is_inhouse = true;
      }
      if (this.caseSourceFilter === "sendout") {
        params.is_sendout = true;
      }
      if (this.caseSourceFilter === "inhouse") {
        params.is_inhouse = true;
      }
      if (this.houstonCrossLabFilter !== undefined) {
        params.is_cross_lab_registered = this.houstonCrossLabFilter;
      }
      // A cross-lab case is finalised by the lab that did not run the sample.
      if (this.crossLabRegistered && this.crossLabFinaliseFrom) {
        params.sample_run_location =
          this.crossLabFinaliseFrom === "Irving" ? "Houston" : "Irving";
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      if (this.isStatSort == true) {
        params.order_by = "is_stat";
        params.order_type = "desc";
      }
      params.status =
        this.crossLabRegistered && this.crossLabCaseStatus.length
          ? this.crossLabCaseStatus
          : this.selectedStatuses;
      if (this.selectedReportStatus) {
        params.is_new_report = this.selectedReportStatus;
      }
      if (this.emr_not_sent) {
        params.emr_result_not_sent = this.emr_not_sent;
      }
      if (this.billing_sub_status && this.billing_sub_status.length) {
        params.billing_sub_status = this.billing_sub_status;
      }
      if (this.$route.path === "/all-cases/release-pending") {
        params.release = false;
      }
      if (this.$route.path === "/all-cases/new-reports") {
        params.release = true;
      }
      if (this.replaced_insurance) {
        params.replaced_insurance = this.replaced_insurance;
      }
      if (this.isGowthamUser) {
        params.is_old = true;
      }
      if(this.testgo_order_type && this.testgo_order_type.length){
        params.testgo_order_type = this.testgo_order_type
      }
      if (this.selectedFaxFlag) {
        params.fax_bidirectional = this.selectedFaxFlag
      }
      if (this.tatNotCrossedFlag) {
        params.tat_crossed = this.tatNotCrossedFlag
      }
      if (this.priorityFlag) {
        params.is_priority = true
      }
      if (this.insuranceExceptionFlag) {
        params.insurance_exception_status = "PENDING"
      }
      if (this.samplesReceivedTab) {
        params.samples_received_tab = this.samplesReceivedTab
      }
      return params;
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllCases();
    },
    getAutoCompleteCases() {
      // Show the search spinner immediately (covers the debounce + request time)
      this.searching = true;
      // persist current search term so it survives tabs reloads
      try {
        localStorage.setItem(
          "allCases_search_string",
          this.search_string || ""
        );
      } catch (e) {
        // ignore
      }
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.page = 1;
        this.fetchAllCases();
        this.debounceTimer = null;
      }, 600);
    },
    onSearchClear() {
      this.search_string = "";
      try {
        localStorage.removeItem("allCases_search_string");
      } catch (e) {
        // ignore
      }
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
      // Immediately remove selectedString from route so navigating tabs quickly
      // does not repopulate the search from the stale query param
      const query = { ...this.$route.query };
      delete query.selectedString;
      this.$router.replace({ query }).catch(() => {});
      this.page = 1;
      this.fetchAllCases();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllCases();
    },
    clearTest() {
      this.caseType = [];
      this.test_info = [];
      this.fetchAllCases();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.fetchAllCases();
    },
    onDateTypeChange() {
      // Persist the choice as a filter preference (localStorage + profile).
      this.saveFilterPreferences();
      // Only re-query if a date range is active; otherwise just remember the choice.
      if (this.fromDate || this.toDate) {
        this.handleCurrentChange(1);
      }
    },
    // Range guards: no future dates, and From/To can't cross each other.
    disabledFromDate(date) {
      if (date > new Date()) return true;
      if (this.toDate) return moment(date).isAfter(moment(this.toDate), "day");
      return false;
    },
    disabledToDate(date) {
      if (date > new Date()) return true;
      if (this.fromDate) return moment(date).isBefore(moment(this.fromDate), "day");
      return false;
    },
    onFromDateChange() {
      // If the current To Date is now earlier than From, clear it to avoid an invalid range.
      if (
        this.fromDate &&
        this.toDate &&
        moment(this.toDate).isBefore(moment(this.fromDate), "day")
      ) {
        this.toDate = "";
      }
      this.handleCurrentChange(1);
    },
    handleCurrentChangeCaseType(page) {
      this.page = page;
      this.test_info = [];
      this.fetchAllTestPanels();
      this.fetchAllCases();
    },
    handleTest(page) {
      this.page = page;
      this.fetchAllCases();
    },
    async fetchAllTestPanels() {
      const singleType = this.caseType.length === 1 ? this.caseType[0] : null;
      if (!singleType) {
        this.testIds = {};
        this.testNames = [];
        return;
      }
      await this.$store.dispatch("labTests/fetchAllLabTests", {
        get_all: true,
        case_type_code: singleType,
      });
      if (this.getAllLabTests) {
        this.testNames = [];
        for (let caseData of this.getAllLabTests) {
          this.testNames.push(caseData);
        }
        this.testIds = {};
        let uniqueObject = {};
        if (singleType == caseConstants.CASE_TYPE_TOXICOLOGY) {
          this.testNames = this.testNames.map((e) => {
            if (
              e.category_code == "SCREENING" ||
              e.category_code == "SCREENING_VALIDITY"
            ) {
              e.category = "SCREENING";
            } else if (
              e.category_code == "ETG_ETS" ||
              e.category_code == "ETG/ETS"
            ) {
              e.category = "ETG/ETS";
            } else if (
              e.category_code == "ORAL_FLUID_TOX_CONFIRMATION"
            ) {
              e.category = "Oral Fluid TOX Confirmation";
            } else if (
              e.category_code == "ORAL_FLUID_TOX_SCREENING"
            ) {
              e.category = "Oral Fluid TOX Screening";
            } else {
              e.category = "CONFIRMATION";
            }
            return e;
          });
        }

        let categories = Array.from(
          new Set(this.testNames.map((e) => e.category))
        );

        this.testIds = categories.map((category) => {
          let tests = this.testNames
            .filter((t) => t.category == category)
            .map((e) => e._id);
          return {
            category,
            tests,
          };
        });
      } else {
        this.testNames = [];
        this.testIds = {};
      }
    },

    async fetchAllCases() {
      // Guard against out-of-order responses: capture a sequence id for this
      // request and ignore its result if a newer request has been issued since.
      // Prevents a slow, stale search (e.g. "TDC2") from overwriting the results
      // and URL for a newer one (e.g. "TDC260").
      const requestSeq = ++this.fetchSeq;
      try {
        let params = this.prepareParams();
        this.loading = true;
        const listAction = this.crossLabRegistered
          ? "cases/fetchCrossLabRegisteredCases"
          : "cases/fetchAllCases";
        await this.$store.dispatch(listAction, {
          ...params,
          __requestSeq: requestSeq,
        });
        if (requestSeq !== this.fetchSeq) return;
        this.updateQueryParams(params);
        this.loading = false;
        this.searching = false;
      } catch (error) {
        if (requestSeq === this.fetchSeq) {
          this.loading = false;
          this.searching = false;
        }
        console.log(error);
      }
    },
    async syncTat() {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/syncTat");
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    handleSelectionChange(rows) {
      if (rows) {
        this.selectedCaseIds = [];
        for (let caseData of rows) {
          this.selectedCaseIds.push(caseData._id);
        }
        this.selectedCases = rows.filter((row) => !row.samples_received);
      } else {
        this.selectedCaseIds = [];
        this.selectedCases = [];
      }
    },
    async onBulkSendFax() {
      this.bulkFaxLoading = true;
      try {
        await this.$store.dispatch("cases/bulkSendFax", {
          case_ids: this.selectedCaseIds,
          lab: this.getUserPrimaryLabId,
        });
        successNotification("Fax sent successfully for selected cases.");
        this.selectedCaseIds = [];
        await this.fetchAllCases();
      } catch (err) {
        errorNotification("Failed to send fax. Please try again.");
      }
      this.bulkFaxLoading = false;
    },
    goToCaseView(caseId) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: caseId },
        query: {
          ...this.$route.query,
          redirectRoute: this.$route.name,
          status: this.selectedStatuses,
        },
      });
    },
    async onRestore(id) {
      this.$confirm("Are you sure to Restore case?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.restoreCase(id);
      });
    },
    async restoreCase(caseId) {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/restoreArchivedCase", caseId);
        if (this.getRestoreCaseStatus) {
          successNotification("Case restored Successfully");
          await this.fetchAllCases(1);
        } else {
          errorNotification("An Error occured while restoring.");
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    goToConcurrentCase(emrQuery, caseId) {
      this.$router.push({
        name: "Concurrent-Case-Information-Update",
        params: { case_id: caseId },
        query: {
          ...this.$route.query,
          isEMR: emrQuery,
        },
      });
    },
    async onViewPriliminaryReports(report) {
      this.loading = true;
      let testReportsData = report.test_reports;
      for (let i = 0; i < testReportsData.length; i++) {
        await this.$store.dispatch("cases/generateTestReport", {
          accession_id: report.accession_id,
          case_type: report.case_type,
          report_id: testReportsData[i].report_id,
          test_results_id: testReportsData[i].test_results_id,
          result_file_id: testReportsData[i].result_file_id,
          skip_download: true,
        });
        if (testReportsData[i].is_priliminary_report) {
          let routerData = this.$router.resolve({
            name: "supplementaryReportView",
            params: {
              report_id: testReportsData[i]._id,
              case_id: report._id,
            },
          });
          window.open(routerData.href, "_blank");
        }
        await this.testReportsViewLog(report, testReportsData[i]);
        await this.testReportsDownloadLog(report, testReportsData[i]);
        this.initData();
      }
    },
    async onViewReports(report) {
      try {
        this.loading = true;
        let testReportsData = report.test_reports;
        for (let i = 0; i < testReportsData.length; i++) {
          await this.$store.dispatch("cases/generateTestReport", {
            accession_id: report.accession_id,
            case_type: report.case_type,
            report_id: testReportsData[i].report_id,
            test_results_id: testReportsData[i].test_results_id,
            result_file_id: testReportsData[i].result_file_id,
            skip_download: true,
          });
          if (
            (testReportsData[i].is_manually ||
              testReportsData[i].additional_report_merged ||
              testReportsData[i].additional_report_already_merged ||
              testReportsData[i].download_ready) &&
            testReportsData[i].mark_for_physician
          ) {
            let routerData = this.$router.resolve({
              name: "supplementaryReportView",
              params: {
                report_id: testReportsData[i]._id,
                case_id: report._id,
              },
            });
            window.open(routerData.href, "_blank");
          } else {
            if (testReportsData[i].mark_for_physician) {
              let routerData = this.$router.resolve({
                name: "ResultFileTestReports",
                params: {
                  report_id: testReportsData[i]._id,
                  case_id: report._id,
                },
              });
              window.open(routerData.href, "_blank");
            }
          }
          await this.testReportsViewLog(report, testReportsData[i]);
          await this.testReportsDownloadLog(report, testReportsData[i]);
        }
        this.initData();
      } catch (error) {
        this.loading = false;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    goToSendOutReports(testId) {
      this.$router.push({
        name: "SendOutsView",
        query: {
          case_id: testId,
        },
      });
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedCase: params.case_type,
        selectedTest: this.test_info.map((tests) => {
          const found = this.testIds.find((t) => t.tests === tests);
          return found ? found.category : null;
        }).filter(Boolean),
        selectedHospital: params.hospitals,
        selectedHospitalName: Array.isArray(this.selectedHospital)
          ? this.selectedHospital.map((h) => (h && h.name) || "")
          : undefined,
        selectedUser: params.test_performed_by,
        selectedAccessionCreatedBy: params.accession_created_by,
        selectedMarketer: params.hospital_marketers,
        selectedDateOfBirth: params.date_of_birth,
        selectedPhysician: params.ordering_physician,
        selectedPhysicianName:
          this.physiciansData && Array.isArray(this.physiciansData.data)
            ? (Array.isArray(params.ordering_physician)
                ? params.ordering_physician
                : []
              ).map(
                (id) =>
                  (this.physiciansData.data.find((p) => p._id === id) || {})
                    .name || ""
              )
            : undefined,
        selectedString: params.search_string,
        selectedPatientName: params.patient_name,
        selectedEMR: params.emr,
        selectedAccessionId: params.accession_id,
        selectedPageSize: params.limit,
        selectedCaseId: this.$route.query.selectedCaseId,
        selectedSearchBy: this.searchBy || undefined,
        selectedCaseOrderBy:
          this.isStatSort == true ? params.order_by : params.order_by,
        selectedCaseOrderType:
          this.isStatSort == true ? params.order_type : params.order_type,
        is_stat: this.priority,
        tat_colour: this.tat_colour,
        fromDate: this.fromDate,
        toDate: this.toDate,
        selectedException: params.billing_sub_status,
        selectedPlatform: params.testgo_order_type,
        selectedCaseSource: this.caseSourceFilter,
        selectedHoustonOnly: this.houstonOnlyCases || undefined,
        selectedCaseStatus: this.crossLabRegistered
          ? this.crossLabCaseStatus
          : undefined,
        selectedFinaliseFrom:
          (this.crossLabRegistered && this.crossLabFinaliseFrom) || undefined
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },

    onPrintBarCodes() {
      let urlData = this.$router.resolve({
        name: "MultipleBarcodes",
        path: "multiple-barcodes",
        query: {
          case_ids: this.selectedCaseIds,
        },
      });
      window.open(urlData.href, "_blank");
    },
    onPrintQrCodes() {
      let urlData = this.$router.resolve({
        name: "MultipleQrcodes",
        path: "multiple-qrcodes",
        query: {
          case_ids: this.selectedCaseIds,
        },
      });
      window.open(urlData.href, "_blank");
    },
    // Short text for the pill under the accession id.
    insuranceHoldLabel(hold) {
      if (hold.state !== "ON_HOLD") {
        return "INS HOLD OVER";
      }
      const msLeft = hold.hold_until
        ? new Date(hold.hold_until).getTime() - Date.now()
        : 0;
      if (msLeft <= 0) {
        return "INS HOLD";
      }
      const hours = Math.floor(msLeft / 3600000);
      const minutes = Math.floor((msLeft % 3600000) / 60000);
      return `INS HOLD · ${hours ? hours + "h " : ""}${minutes}m`;
    },
    // Full explanation shown on hover.
    insuranceHoldTitle(hold) {
      const status = String(hold.exception_status || "").toLowerCase();
      if (hold.state !== "ON_HOLD") {
        return `Insurance exception is still ${status}, but the 24-hour hold has passed. This case can be finalized.`;
      }
      const until = hold.hold_until
        ? this.momentWithTimezone(hold.hold_until, "MM-DD-YYYY hh:mm A")
        : "";
      return (
        `Insurance exception is ${status}. Finalizing is on hold` +
        (until ? ` until ${until}` : "") +
        ", or until the exception is approved."
      );
    },
    onBarcodeMenuCommand(command) {
      const hasSelection = this.selectedCaseIds.length > 0;
      switch (command) {
        case "barcode":
          if (hasSelection) this.onPrintBarCodes();
          else this.generateBarcodesDialogVisible = true;
          break;
        case "qrcode":
          if (hasSelection) this.onPrintQrCodes();
          else this.generateQrcodesDialogVisible = true;
          break;
        case "test":
          if (hasSelection) this.onPrintTestBarCodes();
          else this.generateTestBarcodesDialogVisible = true;
          break;
        case "external":
          this.openExternalLabBarcodesDialog();
          break;
      }
    },
    async openExternalLabBarcodesDialog() {
      this.external_lab_barcode_lab_ids = [];
      this.external_lab_barcode_from_date = "";
      this.external_lab_barcode_to_date = "";
      this.externalLabBarcodesDialogVisible = true;
      this.externalLabsLoading = true;
      await this.$store.dispatch("labs/fetchExternalLabs");
      this.externalLabsLoading = false;
    },
    onGenerateExternalLabBarcodes() {
      if (this.isExternalLabBarcodeFormIncomplete) {
        return;
      }
      const query = { lab_ids: this.external_lab_barcode_lab_ids };
      if (this.selectedCaseIds.length) {
        query.case_ids = this.selectedCaseIds;
      } else {
        query.from_date = this.external_lab_barcode_from_date;
        query.to_date = this.external_lab_barcode_to_date;
      }
      let urlData = this.$router.resolve({
        name: "MultipleExternalLabBarcodes",
        path: "multiple-external-lab-barcodes",
        query,
      });
      this.externalLabBarcodesDialogVisible = false;
      window.open(urlData.href, "_blank");
    },
    onPrintTestBarCodes() {
      let urlData = this.$router.resolve({
        name: "MultipleTestBarcodes",
        path: "multiple-test-barcodes",
        query: {
          case_ids: this.selectedCaseIds,
        },
      });
      window.open(urlData.href, "_blank");
    },
    onDelete(id) {
      this.requestArchiveCase = id;
      this.takeReasonDialog = true;
    },
    async deleteCase(reason) {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/deleteCase", {
          case_id: this.requestArchiveCase,
          reason: reason,
        });
        if (this.getCaseDeleteStatus) {
          successNotification("Case archived successfully");
          this.requestArchiveCase = "";
          await this.fetchAllCases();
        } else {
          errorNotification(
            this.getCaseDeleteError || "Error while deleting case"
          );
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },

    async onBulkAcknowledgment(){
      this.showBulkAcknowledgmentDialog = true;
    },

    async sampleReceived(caseData){
      try {
        this.sampleReceivedLoading = true
        let params = {
          case_id: caseData?._id,
          samples_received: true,
        }
        await this.$store.dispatch("cases/acknowledgeSampleReceived", params)
        if (this.getUpdatedSampleReceivedStatus) {
          successNotification("Samples Received acknowledged successfully");
          this.fetchAllCases();
        } else {
          errorNotification("Error while acknowledging samples received");
        }
        this.sampleReceivedLoading = false
      } catch(err){
        this.sampleReceivedLoading = false
        console.log(err)
      } finally {
        this.sampleReceivedLoading = false
      }
    },

    async onBulkSamplesReceived(){
      this.showBulkAcknowledgmentDialog = true;
    },
    onSamplesReceivedBarButton(){
      this.showBulkAcknowledgmentDialog = true;
    },

    async confirmBulkSamplesReceived(){
      if (!this.selectedCaseIds || !this.selectedCaseIds.length) {
        errorNotification("No cases selected. Please select at least one case.");
        return;
      }
      try {
        this.bulkSampleReceivedLoading = true
        const params = {
          case_ids: this.selectedCaseIds,
          samples_received: true,
        }
        await this.$store.dispatch("cases/bulkAcknowledgeSamplesReceived", params)
        if (this.getUpdatedSampleReceivedBulkStatus) {
          successNotification("Samples Received acknowledged successfully");
          this.showBulkAcknowledgmentDialog = false;
          await this.fetchAllCases();
        } else {
          errorNotification("Error while acknowledging samples received");
        }
        this.bulkSampleReceivedLoading = false
      } catch(err) {
        this.bulkSampleReceivedLoading = false
        console.log(err)
      } finally {
        this.bulkSampleReceivedLoading = false
      }
    },
  },
  watch: {
    getAllCases() {
      this.updateColumnVisibility();
    },
    getProfileData(newVal) {
      // Reload saved filter order/visibility once the profile is available
      if (newVal && newVal.filter_preferences && newVal.filter_preferences.all_cases) {
        this.loadFilterPreferences();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Keep the whole top toolbar on a single line: the left cluster sizes to
   its content and the right cluster takes the remaining width, so the
   action buttons never wrap onto a second line (no empty gap) and the
   Accession input never overflows into the From Date picker. */
/* Pill under the accession id for cases with an open insurance exception.
   The labels are kept short enough to fit the 150px accession column. */
.insurance-hold-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  margin-top: 4px;
  padding: 2px 8px 2px 6px;
  box-sizing: border-box;
  border-radius: 999px;
  background: #e8f5ee;
  color: #1f7a4d;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.2px;
  line-height: 1.4;
  white-space: nowrap;
  cursor: default;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .insurance-hold-dot {
    width: 6px;
    height: 6px;
    flex: 0 0 auto;
    border-radius: 50%;
    background: currentColor;
  }

  /* Same violet as the held row's highlight. */
  &.is-on-hold {
    background: #e4dcff;
    color: #4f35c9;
  }
}

.listings-navbar {
  /* One line when everything fits; otherwise the right cluster drops to its
     own line instead of sliding over the left one. */
  :deep(.el-row) {
    flex-wrap: wrap;
  }
  .toolbar-left {
    flex: 0 1 auto;
    width: auto;
    max-width: 100%;
  }
  .toolbar-right {
    flex: 1 1 auto;
    width: auto;
    max-width: 100%;
  }
  /* Force a fixed gap between the Accession search and the From Date. */
  .toolbar-right .list-items-group-15 > li:first-child {
    margin-left: 24px;
  }
  .toolbar-right .list-items-group-15 {
    flex-wrap: nowrap;
  }
  /* The barcode buttons wrap among themselves if they alone outgrow the row. */
  .barcode-print {
    flex-wrap: wrap;
    row-gap: 8px;
  }

  /* Give the Accession search a fixed width and slim the date pickers a
     little so the right cluster stops sliding left over the search box. */
  .toolbar-left .search-input-lg {
    width: 440px;
    flex: 0 0 440px;
  }
  .toolbar-right .search-with-date-input {
    width: 118px;
  }
  /* Tighten spacing between the right-side controls to make room for the
     gap before From Date. */
  .toolbar-right .list-items-group-15 > li:not(:last-child) {
    margin-right: 8px;
  }

  /* Narrow screens can't fit everything on one line — fall back to
     wrapping so controls stack cleanly instead of overlapping. */
  @media screen and (max-width: 1400px) {
    :deep(.el-row) {
      flex-wrap: wrap;
    }
    .toolbar-left,
    .toolbar-right {
      flex: 1 1 100%;
    }
    .barcode-print,
    .toolbar-right .list-items-group-15 {
      flex-wrap: wrap;
      row-gap: 8px;
    }
  }
}

/* ---- Customizable / draggable filters ---- */
.filters-draggable {
  .filter-drag-item {
    display: flex;
    align-items: center;
    gap: 4px;

    /* Keep every filter control on a single, uniform height so plain
       inputs (Patient Name) and multi-selects (Case Type) don't render
       taller than the surrounding dropdowns. */
    :deep(.el-input__inner) {
      height: 35px !important;
      line-height: 35px;
    }
    :deep(.el-select__tags) {
      max-height: 33px;
      flex-wrap: nowrap;
      overflow: hidden;
    }
  }
  .filter-drag-handle {
    cursor: grab;
    color: #b7b7b7;
    font-size: 14px;
    line-height: 1;
    user-select: none;
    padding: 0 2px;
    &:hover {
      color: #273480;
    }
    &:active {
      cursor: grabbing;
    }
  }
}
.filter-ghost {
  opacity: 0.5;
  background: #eef0fb;
  border-radius: 6px;
}
.filter-customize-btn.el-button {
  height: 35px !important;
  min-height: 35px !important;
  border-radius: 6.4px !important;
  border: 1px solid #dedbdb;
  background: #fff;
  color: #273480;
  font-size: 12px;
  padding: 0 12px !important;
  margin: 0;
}
.filter-customize-panel {
  .fc-title {
    font-size: 12px;
    font-weight: 600;
    color: #273480;
    margin: 0 0 8px;
  }
  .fc-row {
    padding: 2px 0;
  }
  .fc-reset {
    margin-top: 6px;
    color: #273480;
  }
}
.filter-toggle-btn.el-button {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  padding: 0 8px !important;
  margin: 0;
  border-radius: 6.4px !important;
  border: 1px solid #dedbdb;
  background: #fff;
  color: #273480;
  cursor: pointer;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.3s ease;
  &:hover,
  &:focus {
    background: #273480;
    border-color: #273480;
    color: #fff;
  }
}
.slide-filters-enter-active,
.slide-filters-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
  max-height: 200px;
  opacity: 1;
}
.slide-filters-enter-from,
.slide-filters-leave-to {
  max-height: 0;
  opacity: 0;
  margin-top: 0 !important;
}
</style>
<style lang="scss">
.rerun-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #c2410c;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  cursor: help;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #9a3412;
  }
}
.fax-retry-badge {
  position: absolute;
  left: -13px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #F56C6C;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  height: 16px;
  min-width: 9px;
  line-height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  text-align: center;
  cursor: help;
  display: inline-block;
}

.text-muted {
  color: #909399;
}

.test-reports {
  display: flex;
  align-items: center;
  padding: 4px 5px;

  .regular-reports {
    &.single-report {
      margin-left: 20px;
    }

    h5 {
      color: #0a5da6;
      font-size: 14px;

      span {
        color: #bdbdbd;
      }
    }
  }

  .repots {
    h5 {
      color: #0a5da6;
    }
  }
}

.left-dropdown {
  text-align: left;
}

.test-tabs {
  padding: 0;

  .el-tabs__active-bar {
    height: 3px;
    background-color: #0a5da6;
    border-radius: 25px;
  }

  .el-tabs__item.is-active {
    color: #0a5da6;
    font-weight: 600;
  }

  .el-tabs__item {
    color: #828282;
  }

  .el-tabs__nav-scroll {
    padding: 0 18px;
  }

  .types {
    padding: 0 5px;

    .case-type {
      &.view-reports-dialog {
        .el-button {
          width: 100%;
          min-height: 36px;
          padding: 0 17px;
          background-color: #f2f6f9;
          border: 1px dashed #bababc;

          span {
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              margin-right: 6px;
            }

            p {
              margin-left: 8px;
              color: #828282;
            }
          }
        }
      }

      .el-input__inner {
        height: 36px;
        border: 1px solid rgba(86, 204, 242, 0.8);
      }
    }

    .btn {
      margin-top: 23px;

      .el-button {
        min-height: 36px;
        padding: 8px 24px;
        font-size: 14px;
        font-weight: 600;
        border-radius: 7px;
      }
    }
  }

  .mark {
    margin-left: 15px;
  }

  .panel {
    .documents {
      display: none;
    }

    .el-table__header {
      color: rgba(0, 0, 0, 0.8);
      border-spacing: 0 5.5px;
      border-radius: 25px;
    }

    .el-table {
      background: rgb(238, 242, 245);

      .el-table__cell {
        padding: 5px 0;
      }

      .el-table__header-wrapper {
        border-radius: 10px;
      }

      .el-table__body-wrapper {
        border-radius: 6px;
      }

      .el-table__cell {
        .cell {
          font-weight: 500;
        }
      }
    }

    .el-table thead {
      color: rgba(0, 0, 0, 0.8);
    }

    .physician-btn {
      .el-switch .el-switch__core {
        width: 34px !important;
        height: 15px;
        background-color: #0a5da6;
        border: none;

        .el-switch__action {
          top: 3px;
          left: 2px;
          width: 9px;
          height: 9px;
        }
      }

      .el-switch__label.is-active {
        color: #0a5da6;
      }

      .el-switch.is-checked {
        .el-switch__core {
          width: 34px !important;
          height: 15px;
          background-color: #4bb543 !important;
          border: none;
        }

        .el-switch__action {
          top: 2.2px;
          left: 38.5px;
          width: 10px;
          height: 10px;
        }
      }
    }

    .title {
      color: #2f80ed;

      img {
        color: #eb5757;
        vertical-align: middle;
      }
    }
  }

  .action-test-icons {
    display: flex;

    li {
      margin-right: 10px;

      .el-button {
        min-height: auto;
        padding: 0;
        background: none;
        border: none;
        transition: all 0.2s;

        &:hover {
          background-color: #eef2f5;
        }

        &:active {
          background-color: #eef2f5;
        }

        &:focus {
          background-color: #eef2f5;
        }

        img {
          color: red;

          &:hover {
            color: #0a5da6;
          }
        }
      }
    }
  }
}

.documents {
  padding: 0 20px;

  .el-tabs__item.is-active {
    color: #0a5da6;
    font-weight: 500;
  }

  .el-tabs__active-bar {
    background-color: #0a5da6;
    border-radius: 25px;
  }

  .document-container {
    display: grid;
    align-items: center;

    gap: 10px;
    grid-template-columns: 230px 230px;
  }

  .document-cell {
    display: grid;
    align-items: center;
    padding: 0 0.3rem;
    background-color: #fff;
    border: 1px solid #56ccf2;
    border-radius: 7px;

    grid-template-columns: 9% 75% 8% 10%;

    img {
      width: 18px;
      height: 18px;
    }

    .cancel {
      width: 15px;
      height: 15px;
    }

    p {
      margin-bottom: 0;
      font-size: 14px;
      font-weight: 500;
    }

    .demo-progress {
      .el-progress--line {
        width: 230px;

        .el-progress-bar__outer {
          height: 5px !important;
          background-color: #9ae0f7;
        }

        .el-progress-bar__inner {
          height: 5px;
          background-color: #2d9cdb;
        }
      }

      .el-progress__text {
        color: #828282;
      }
    }
  }

  .document-cell {
    display: grid;
    align-items: center;
    padding: 0 0.3rem;
    background-color: #fff;
    border: 1px solid #56ccf2;
    border-radius: 7px;

    grid-template-columns: 9% 80% 8% 10%;

    img {
      width: 18px;
      height: 18px;
    }

    .cancel {
      width: 15px;
      height: 15px;
    }

    p {
      font-size: 14px;
      font-weight: 500;
    }
  }
}

.listings-navbar {
  .barcode-print {
    .el-button--small {
      padding: 7px 15px;
      border-radius: 8px;

      &:hover {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }

      &:focus {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }

      &:active {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }
    }
  }
}

.btn-synced {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #4bb543;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #4bb543;
  border-radius: 4px !important;

  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #4bb543;
    color: #4bb543;
  }
}

.btn-sync {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #5162fd;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #5162fd;
  border-radius: 4px !important;

  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #5162fd;
    color: #5162fd;
  }
}

.btn-processing {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #f28b0c;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #f28b0c;
  border-radius: 4px !important;

  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #f28b0c;
    color: #f28b0c;
  }
}

.el-badge__content.is-fixed {
  font-size: 12px;
  line-height: 18px;
  position: absolute;
  background: #273480;
  top: 3px;
  height: 16px;
  right: calc(-5px + var(--el-badge-size) / 2);
  transform: translateY(-50%) translateX(100%);
}

.validation-button {
  display: block;
  margin-bottom: -5px;

  img {
    width: 25px;
  }
}

.reorder-radio {
  .el-radio-group {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;

    .el-radio__input .el-radio__inner {
      border-color: transparent;
      box-shadow: 0 0 0 1px #ced1d6;
    }

    .el-radio__input.is-checked .el-radio__inner {
      background-color: #0a5da6;
      border-color: #ffffff;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #0a5da6;
    }
  }
}
.bulk-sample-received-dialog {
  width: 820px !important;
  max-width: calc(100vw - 40px) !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  box-shadow: 0 22px 60px rgba(20, 28, 55, 0.2) !important;

  .el-dialog__header {
    padding: 22px 28px 18px !important;
    margin-right: 0 !important;
    border-bottom: 1px solid #e8ecf4 !important;
    background: linear-gradient(180deg, #fbfcff 0%, #f6f8fd 100%) !important;
  }

  .el-dialog__headerbtn {
    display: none !important; // Hide default close button
  }

  .el-dialog__body {
    padding: 24px 28px !important;
    background: #ffffff !important;
  }

  .el-dialog__footer {
    padding: 18px 28px 22px !important;
    border-top: 1px solid #e8ecf4 !important;
    background: #fbfcff !important;
  }

  .dialog-header-custom {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    width: 100% !important;

    .header-title {
      display: flex !important;
      align-items: center !important;
      gap: 12px !important;
      color: #1a1a2e !important;
      font-size: 18px !important;
      font-weight: 600 !important;
      line-height: 26px !important;

      .header-icon {
        width: 26px !important;
        height: 26px !important;
        object-fit: contain !important;
      }
    }

    .close-btn {
      width: 34px !important;
      height: 34px !important;
      min-height: 34px !important;
      padding: 0 !important;
      border: none !important;
      border-radius: 50% !important;
      background: #eef1f8 !important;
      font-size: 18px !important;
      color: #8c8fa7 !important;
      cursor: pointer !important;

      &:hover {
        color: #303f8f !important;
        background: #e4e8f5 !important;
      }
    }
  }

  .dialog-body-content {
    display: flex !important;
    flex-direction: column !important;
    gap: 18px !important;
  }

  .selection-summary-card {
    display: flex !important;
    align-items: center !important;
    gap: 16px !important;
    padding: 18px 20px !important;
    border: 1px solid #e4e8f5 !important;
    border-radius: 10px !important;
    background: #f7f9ff !important;

    .selection-count-badge {
      flex: 0 0 48px !important;
      width: 48px !important;
      height: 48px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      border-radius: 50% !important;
      background: #303f8f !important;
      color: #ffffff !important;
      font-size: 19px !important;
      font-weight: 700 !important;
      line-height: 1 !important;
    }

    .selection-text {
      flex: 1 !important;
      min-width: 0 !important;

      .selection-title {
        margin: 0 0 4px 0 !important;
        color: #1a1a2e !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        line-height: 24px !important;
      }

      .selection-subtitle {
        margin: 0 !important;
        color: #6b7280 !important;
        font-size: 13px !important;
        line-height: 20px !important;
      }
    }
  }

  .cases-table-wrapper {
    display: flex !important;
    flex-direction: column !important;
    gap: 10px !important;

    .table-label {
      color: #1a1a2e !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      line-height: 22px !important;
      margin: 0 !important;
    }

    .cases-table {
      border-radius: 8px !important;
      overflow: hidden !important;
      border: 1px solid #e8ecf4 !important;

      .el-table__header-wrapper {
        th.el-table__cell {
          height: 44px !important;
          padding: 0 14px !important;
          background: #f7f8fb !important;
          color: #5a5f7a !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          letter-spacing: 0.4px !important;
          text-transform: uppercase !important;
          border-bottom: 1px solid #e8ecf4 !important;
        }
      }

      .el-table__body-wrapper {
        td.el-table__cell {
          height: 50px !important;
          padding: 0 14px !important;
          color: #1a1a2e !important;
          font-size: 13px !important;
          border-bottom: 1px solid #f0f0f5 !important;
        }

        tr:last-child td.el-table__cell {
          border-bottom: none !important;
        }
      }

      .el-table__cell .cell {
        padding: 0 !important;
        line-height: 20px !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
      }

      .accession-id-cell {
        font-weight: 500 !important;
        color: #303f8f !important;
      }

      .case-type-badge {
        display: inline-block !important;
        max-width: 100% !important;
        padding: 4px 12px !important;
        background: #f0f2f9 !important;
        border-radius: 14px !important;
        color: #4a507a !important;
        font-size: 12px !important;
        font-weight: 500 !important;
        line-height: 20px !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
      }

      .patient-name-cell {
        font-weight: 500 !important;
        color: #1a1a2e !important;
      }

      .test-tube-list {
        display: flex !important;
        align-items: center !important;
        flex-wrap: wrap !important;
        gap: 6px !important;
        max-width: 100% !important;
      }

      .test-tube-badge {
        display: inline-flex !important;
        align-items: center !important;
        padding: 4px 9px !important;
        border: 1px solid #cbd5ee !important;
        border-radius: 6px !important;
        background: #eef2ff !important;
        color: #303f8f !important;
        font-size: 11px !important;
        font-weight: 700 !important;
        line-height: 18px !important;
        white-space: nowrap !important;
      }

      .empty-tube-cell {
        color: #9aa1b5 !important;
      }
    }
  }

  .tat-info-card {
    display: flex !important;
    align-items: flex-start !important;
    gap: 14px !important;
    padding: 16px 18px !important;
    border: 1px solid #dfe5f5 !important;
    border-radius: 10px !important;
    background: #fbfcff !important;

    .tat-info-icon {
      flex: 0 0 32px !important;
      width: 32px !important;
      height: 32px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      border-radius: 50% !important;
      background: #edf2ff !important;
      color: #303f8f !important;
      font-size: 17px !important;
      line-height: 1 !important;
    }

    .tat-info-text {
      flex: 1 !important;
      min-width: 0 !important;

      .tat-info-title {
        margin: 0 0 4px 0 !important;
        color: #303f8f !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        line-height: 20px !important;
      }

      .tat-info-description {
        margin: 0 !important;
        color: #6b7280 !important;
        font-size: 13px !important;
        line-height: 20px !important;
        max-width: 690px !important;
      }
    }
  }

  .dialog-footer-custom {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 12px !important;

    .btn-cancel,
    .btn-confirm {
      min-width: 110px !important;
      height: 40px !important;
      padding: 0 20px !important;
      border-radius: 6px !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      letter-spacing: 0.3px !important;
    }

    .btn-cancel {
      color: #6b7280 !important;
      border-color: #d1d5db !important;
      background: #ffffff !important;

      &:hover {
        color: #303f8f !important;
        border-color: #c5cdef !important;
        background: #f7f8ff !important;
      }
    }

    .btn-confirm {
      color: #ffffff !important;
      border-color: #303f8f !important;
      background: #303f8f !important;

      &:hover {
        border-color: #263475 !important;
        background: #263475 !important;
      }

      &.is-disabled,
      &.is-disabled:hover {
        color: #ffffff !important;
        border-color: #c8cddc !important;
        background: #c8cddc !important;
        cursor: not-allowed !important;
      }
    }
  }

  @media screen and (max-width: 640px) {
    max-width: calc(100vw - 24px) !important;

    .el-dialog__header,
    .el-dialog__body,
    .el-dialog__footer {
      padding-left: 18px !important;
      padding-right: 18px !important;
    }

    .selection-summary-card,
    .tat-info-card {
      align-items: flex-start !important;
    }

    .dialog-footer-custom {
      flex-direction: column-reverse !important;

      .btn-cancel,
      .btn-confirm {
        width: 100% !important;
      }
    }
  }
}
</style>
